export const LANG_PT_NAME = 'portuguese';
export const LANG_PT_TRANS = {
  'Loading': 'Carregando',
  'Dashboard': 'Painel de Indicadores',
  'My Equipment': 'Meus Equipamentos',
  'My Inventory': 'Meu Inventário',
  'Reports': 'Relatórios',
  'Admin': 'Administrador',
  'TT Admin': 'TT Administrador',
  'My Account': 'Minha Conta',
  'Help': 'Ajuda',
  'Inspections': 'Inspeções',
  'New Inspection': 'Nova Inspeção',
  'Find & Edit Inspection': 'Localizar e Editar Inspeção',
  'Interpret Inspection': 'Interpretar Inspeção',
  'Inspection Planning': 'Planejamento de Inspeção',
  'Download Android App': 'Scarica Android App',
  'Full History': 'Storia Completa',
  'Record an Action': 'Gravar uma Ação',
  'Meter Reading': 'Leitura do Medidor',
  'Meter Change': 'Troca de Horimetro',
  'Setup New Equipment': 'Configurar Novo Equipamento',
  'Find & Edit Equipment': 'Localizar e Editar Equipamento',
  'Relocate Equipment': 'Realocar Equipamento',
  'Inventory': 'Inventário',
  'New Chain or Frame': 'Nova Corrente ou Chassis',
  'Inspection Analysis': 'Análise da Inspeção',
  'Component Life Performance': 'Desempenho da Vida do Componente',
  'Equipment Without Contacts': 'Equipamento Sem Relação',
  'Login Statistics': 'Estatísticas de Acesso',
  'Fleet Component Forecast': 'Previsão do Componente de Frota',
  'Home': 'Home',
  'Customer Contacts': 'Contato de Clientes',
  'User Contacts': 'Contato de Usuários',
  'Job Roles': 'Função',
  'Components': 'Componentes',
  'COMPONENTS': 'Componentes',
  'Equipment': 'Equipamento',
  'Branded Styles': 'Modelos Registrados',
  'Old Setup': 'Configuração Anterior',
  'Preferences': 'Preferências',
  'Logout': 'Sair',
  'TrackCommander Documentation': 'Documentação TrackCommander',
  'What\'s New': 'O que há de novo',
  'About': 'Sobre',
  'Job Role Setup': 'Configurar Função',
  'Job Role Permissions': 'Niveis de Acesso da Função',
  'Job Role Members': 'Membros da Função',
  'Position & Job Status': 'Posição e Status do Trabalho',
  'Component Types': 'Tipos de Componentes',
  'Setup Components': 'Configurar Componentes',
  'Wear Limits (A,B,C,X),': 'Limites de Desgaste (A, B, C, X),',
  'Wear Rate Formulas': 'Formulas de Taxa de Desgaste',
  'Setup Families': 'Configurar Famílias',
  'Setup Makes': 'Configurar o Arranjo',
  'Setup Models': 'Configurar Modelos',
  'Customer': 'Cliente',
  'User': 'Usuário',
  'Search': 'Pesquisar',
  'Job Site': 'Local de Trabalho',
  'Equipment Serial/Unit No': 'Nº de Série/Unidade do Equipamento',
  'Family': 'Família',
  'Make': 'Arranjo',
  'Model': 'Modelos Registrados',
  'Fleet Overview': 'Visão Geral da Frota',
  'Filter': 'Filtrar',
  'Filter Table': 'Tabela de Filtros',
  'Eval (L)': 'Calcula (L)',
  'Eval (R)': 'Calcular ( R)',
  'Serial No.': 'Nº de Série',
  'Unit No.': 'Nº da Unidade',
  'SMU': 'SMU',
  'LTD': 'LTD',
  'Last Inspection Date': 'Data da Última Inspeção',
  'Last Inspect Date': 'Data da Última Inspeção',
  'Back': 'Voltar',
  'Awaiting Interpretation': 'Aguardando Interpretação',
  'This machine has recently been inspected, but the report is not ready. Once interpreted, your PDF report will be available for download.': 'Essa máquina foi inspecionada recentemente, mas o relatório ainda não está pronto. Assim que os dados forem interpretados, seu relatório em PDF estará pronto para Download',
  'Equipment Details': 'Dados do Equipamento',
  'Download Report': 'Baixar Relatório',
  'Inspection Details': 'Dados da Inspeção',
  'Find Inspection': 'Encontrar Inspeção',
  'Equipment History': 'Histórico do Equipamento',
  'Record Action': 'Gravar Ação',
  'Serial Number': 'Nº de Série',
  'Unit Number': 'Nº da Unidade',
  'Next Inspection Date': 'Data da Próxima Inspeção',
  'N/A': 'N / D',
  'Meter Reading (SMU)': 'Leitura do Horímetro',
  'Life to Date (LTD)': 'Vida Até a Data',
  'Chain Serial Number (left)': 'Nº de Série da Corrente (Lado Esquerdo)',
  'Frame Serial Number (left)': 'Nº de Séria do Chassis (Lado Esquerdo)',
  'Chain Serial Number (right)': 'Nº de Série da Corrente (Lado Direito)',
  'Frame Serial Number (right)': 'Nº de Séria do Chassis (Lado Direito)',
  'Left Side Components': 'Componentes do Lado Esquerdo',
  'Worn (%)': 'Desgaste (%)',
  'Component': 'Componente',
  'Part No.': 'Nº Da Peça',
  'Life Lived (CMU)': 'Vida Acumulada',
  'Remaining Life (100%)': 'Vida Remanescente (100%) - Para Reforma',
  'Remaining Life (120%)': 'Vida Remanescente (120%) - Para Destruição',
  'Install Date': 'Data de Instalação',
  'Equipment SMU at Install': 'SMU do Equipamento Na Instalação',
  'Component Hours at Install': 'Horas do Componente Na Instalação',
  'Right Side Components': 'Componentes do Lado Direito',
  'Ruler': 'Régua',
  'Create Favourite': 'Criar Favorito',
  'Component Overview': 'Visão Geral do Componente',
  'Wear Rate Overview': 'Visão Geral da Taxa de Desgaste',
  'Recommendation': 'Recomendação',
  'Status': 'Status',
  'Position': 'Posição',
  'Type': 'Tipo',
  'Track Roller Values -': 'Valor dos Roltes de Esteira',
  'Left': 'Esquerda',
  'Right': 'Direita',
  'hrs': 'hrs',
  'No': 'Não',
  'Yes': 'Sim',
  'Carrier Roller AVG': 'Média do Rolete Superior da Esteira',
  'Track Roller AVG': 'Média dos Roletes Inferiores de Esteira',
  'Track Roller Worst': 'Pior Rolete da Esteira',
  'Outstanding Actions': 'Ações Extraordinárias',
  'Sprocket': 'Roda Motriz',
  'Rear Idler': 'Roda Guia Traseira',
  'Front Idler': 'Roda Guia Dianteira',
  'Shoe': 'Sapata',
  'Bush Turned': 'Bucha Girada',
  'Bush': 'Bucha',
  'Hours on Link': 'Horas No Elo',
  'Link': 'Elo',
  'Current SMU/Hourmeter': 'SMU Atual/Horímetro',
  'Site': 'Local',
  'Unit': 'Unidade',
  'Serial': 'Série',
  'Update to Current Selection': 'Atualizar Para Seleção Atual',
  'Setup Undercarriage': 'Configurar Material Rodante',
  'On Equipment': 'No Equipamento',
  'In Inventory': 'No Inventário',
  'Setup User': 'Configurar Usuário',
  'Setup Customer': 'Configurar Cliente',
  'Setup Job Site': 'Configurar Local de Trabalho',
  'Observation Lists': 'Listas de Observação',
  'Measurement Points': 'Pontos de Medição',
  'Switch App': 'Mudar App',
  'Dashboard Overview': 'Visão Geral do Dashboard',
  'Enlarge': 'Ampliar',
  'Inspections Performed': 'Inspeções Realizadas',
  'Total cost of all repairs recorded each month for the past year. This does not include cost of new equipment or parts. Filter this data down using the search above.': 'Custo Total de todos os reparos registrados a cada mês do ano passado. Isso não inclui o custo de novos equipamentos ou peças. Filtre os dados abaixo utilizando o pesquisar acima.',
  'Total Cost of Repairs': 'Custo Total de Reparos',
  'The current evaluation of all the components you can view based on their last inspection. Filter this data down using the search above.': 'A avaliação atual de todos os componentes com base em sua última inspeção. Filtre esses dados abaixo usando o pesquisar acima.',
  'Inspections are due by today date. This is based on what you searched for in total and not what you see in this page only.': '',
  'Inspections due': 'Inspeções Vencidas',
  'undefined': 'Indefinido',
  'Last Inspection SMU/Hourmeter': 'SMU da Última Inspeção/Horímetro',
  'SMU/Hourmeter': 'SMU/Horímetro',
  'Fleet Condition': 'Condição da Frota',
  'Equipment Overview': 'Visão Geral do Equipamento',
  'Meter Reading (SMU/HourMeter)': 'Leitura do Medidor (Smu/Horímetro)',
  'Setup Date': 'Configurar Data',
  'Details': 'Detalhes',
  'Edit': 'Editar',
  'Interpret': 'Interpretar',
  'Inspection History': 'Histórico de Inspeção',
  'Change Meter Unit': 'Horimetro Trocado',
  'Update Meter': 'Atualizar Horímetro',
  'Life Lived': 'Vida Acumulada',
  'Equipment SMU/Hourmeter at Install': 'SMU/Horímetro do Equipamento Na Instalação',
  'Date Installed': 'Data de Instalação',
  'Total Component Repairs Cost (inc. All Components Ever)': 'Custo Total de Reparto dos Componentes (Incluindo Todos os Componentes desde o início)',
  'Total Purchase Cost (inc. Current Components)': 'Custo Total de Aquisição (Incluindo Componentes Atuais)',
  'Right Side Frame': 'Chassis do Lado Direito',
  'Right Side Chain': 'Corrente do Lado Direito',
  'Left Side Frame': 'Chassis do Lado Esquerdo',
  'Left Side Chain': 'Corrente do Lado Esquerdo',
  'PDF Report': 'Relatório em PDF',
  'Tasks': 'Tarefas',
  'Change Jobsite': 'Alterar Local de Trabalho',
  'Setup Equipment': 'Configurar Equipamento',
  'Next Inspection': 'Próxima Inspeção',
  'Brand': 'Marca',
  '(CMU)': '(CMU)',
  '(100% Worn)': '(100% de Desgate)',
  '(120% Worn)': '(120% de Desgaste)',
  'Purchase Cost': 'Custo de Aquisição',
  'Repairs Cost': 'Custo de Reparo',
  'Interpretation': 'Interpretação',
  'Manage Equipment': 'Gerenciar Aquipamento',
  'Meter Reading (SMU/Hourmeter)': 'Leitura do Medidor (SMUHorímetro)',
  'Forward Travel Km': 'Distância Percorrida em Sentido a Frente (Km)',
  'Reverse Travel Km': 'Distância Percorrida em Ré (Km)',
  'Forward Hours': 'Horas em Sentido a Frente',
  'Reverse Hours': 'Horas em Ré',
  'JobSite Comment': 'Comentário Sobre Local de Trabalho',
  'Inspection Comment': 'Comentário Sobre Inspeção',
  'Inspector': 'Inspetor',
  'Inspection Date': 'Data da Inspeção',
  'Track Sag': 'Tensionameneto da Esteira',
  'Cannon Ext.': 'Extensão do Canhão',
  'Dry Joints': 'Nº de Juntas Secas',
  'Scallop': 'Deformação do Link',
  'Add Comment': 'Adicionar Comentário',
  'Interpretation Comment': 'Interpretar Comentário',
  'Create New Quote': 'Criar Nova Cotação',
  'There are currently no quotes.': 'Atualmente não há Cotações',
  'Quotes': 'Cotações',
  'Bar Chart': 'Gráfico de Barras',
  'Additional Observations': 'Observações Adicionais, Resposta',
  'Audit Log': 'Login de Auditoria',
  'Quote': 'Cotar',
  'Release': 'Liberar',
  'Release Report to Customer': 'Liberar Relatório ao Cliente',
  'PDF': 'PDF',
  'Depth Gauge': 'Medidor de Profundidade',
  'UT': 'Medidor de Ultra Som',
  'Eval': 'Calcular',
  'Change tool': 'Trocar Ferramenta',
  'Add photo': 'Adicionar Foto',
  'CMU': 'CMU',
  'Tool': 'Ferramenta',
  'Residual Life': 'Vida Residual',
  'Select Customer': 'Selecionar Cliente',
  'Select Filter': 'Selecionar Filtro',
  'Customer Notes': 'Notas de Clientes',
  'Add New': 'Adicionar Novo',
  'Address To Customer Name': 'Endereçar ao Nome do Cliente',
  'Created Date': 'Data De Criação',
  'Notes': 'Notas',
  'Created By': 'Criado por',
  'Select Job Site': 'Selecionar Local de Trabalho',
  'Select Equipment': 'Selecionar Equipamento',
  'Next': 'Próximo',
  'Save And Interpret': 'Salvar e Interpretar',
  'Change Equipment': 'Alterar Equipamento',
  'Review & Save': 'Revisar e Salvar',
  'General Information': 'Informações Gerais',
  'Abrasive *': 'Abrasivo *',
  'Impact *': 'Impacto *',
  'Moisture *': 'Umidade *',
  'Packing *': 'Acúmulo De Material Na Esteira *',
  'Observations': 'Observações',
  'Reverse Travel Kms': 'Distância Percorrida em Ré (Km)',
  'Reverse Travel hrs': 'Horas Percorridas em Ré',
  'Inspection Date *': 'Data de Inspeção *',
  'Meter Reading(SMU/Hourmeter) *': 'Leitura do Medidor (SMU/Horímetro) *',
  'Inches': 'Polegadas',
  'Change Measurement Unit': 'Alterar Unidade de Medida',
  'Photo': 'Foto',
  'Comment': 'Comentário',
  'Equipment Hours': 'Horas do Equipamento',
  'Forward Travel hrs': 'Horas Percorrida em Sentido a Frente (hrs)',
  'Forward Travel Kms': 'Distância Percorridas em Sentido a Frente',
  'Overall Notes': 'Notas Gerais',
  'Inspection Notes': 'Notas de Inspeção',
  'Jobsite Notes': 'Notas do Local de Trabalho',
  'Underfoot Conditions': 'Condições de Solo',
  'Left Chain': 'Corrente do Lado Esquerdo',
  'Right Chain': 'Corrente do Lado Direito',
  'Left Frame': 'Chassis do Lado Esquerdo',
  'Right Frame': 'Chassis do Lado Direito',
  'Worn(%)': 'Desgaste (%)',
  'Measurement': 'Medida',
  'MM': 'Milímetros',
  'There are currently no recommendations added for this quote.': 'Atualmente não há recomendações adicionais para esta cotação',
  'Calipers': 'Compasso',
  'Pos.': 'Posição',
  'Pos': 'Posição',
  'Worn': 'Desgaste',
  'Unsynced Inspections': 'Inspeções Não Sincronizados',
  'Workshop Repair Estimates': 'Estimativa de Reparos da Oficina',
  'Evaluation': 'Estimativa',
  'Select Model': 'Selecionar Modelo',
  'Select Make': 'Selecionar Arranjo',
  'Jobsite': 'Local de Trabalho',
  'Condition': 'Condição',
  'Actions': 'Ações',
  'How often will you be inspecting this equipment? We will use this to help forecast future inspections.': 'Com qual frequência você irá inspecionar o equipamento? Nós iremos utilizar isso para ajudar a previsionar futuras inspeções',
  'Hours per Day': 'Horas por dia',
  'Inspection Planner': 'Planejador de Inspeção',
  'I will inspect every': 'Inspeção a cada',
  'On average how many days is this equipment in use, and on which days?': 'Em média, cuantos dias este equipamento esta em eso? E em quais dias?',
  'Sat': 'Sáb',
  'Mon': 'Seg',
  'Tue': 'Ter',
  'Wed': 'Qua',
  'Thu': 'Qui',
  'Fri': 'Sex',
  'New SMU/Hourmeter': 'Novo SMU/Horímetro',
  'What is the old SMU/Hourmeter meter reading?': 'O que o antigo SMU/Horímetro está lendo?',
  'What is the new meter SMU/Hourmeter reading?': 'O que o novo SMU/Horímetro está lendo?',
  'What is the date of the replacement?': 'Qual é a data da substituição?',
  'Old SMU/Hourmeter Reading is required': 'Leitura do antigo SMU/Horímetro e Requerida',
  'Application': 'Aplicação',
  'Ranking': 'Classificação',
  'Machine Status': 'Status da Máquina',
  'Please select the customer and job site where this equipment is located.': 'Por favor, selecione o Cliente e o Local de Trabalho que este equipamento está localizado',
  'Create Equipment': 'Criar Equipamento',
  'Would you like to setup a new equipment or modify an existing one?': 'Gostaria de configurar um novo equipamento ou modificar um já existente?',
  'Modify Existing Equipment': 'Modificar Equipamento Existente',
  'How do you identify this equipment?': 'Como você identifica este equipamento?',
  'What type of equipment is this?': 'Que tipo de equipamento é este?',
  'What is the earliest known SMU/Hourmeter and the date of reading for this equipment?': 'Qual é o SMU/Horímetro conhecido mais antigo e a data da leitura deste equipamento?',
  'You can attach a photo of this equipment which can be seen throughout the application.': 'Você pode anexar uma foto deste equipamento que pode ser visto em todo o aplicativo.',
  'You can also set some aditional details, although this is not required.': 'Você também pode definir alguns detalhes Adicionais, embora isso não seja necessário.',
  'Select Customer & Job Site': 'Selecionar Cliente e Local de Trabalho',
  'Additional Information': 'Informações Adicionais',
  'Serial / Unit Number': 'Nº de Série/Unidade',
  'SMU/Hourmeter at Setup': 'SMU/Horímetro do Momento de Configuração',
  'LTD at Setup': 'LTD do momento de configuração',
  'Equipment Setup': 'Configuração do Equipamento',
  'Setup Complete!': 'Configuração Completa!',
  'Now that you have setup your equipment, you need to setup the undercarriage for it before you can start recording inspections.': 'Agora aue você configurou seu equipamento, você precisa configurar seu material rodante antes que você possa começar a gravar inspeções',
  'Setup Undercarriage for This Equipment': 'Configurar material rodante para este equipamento',
  'Setup Another Equipment': 'Configurar outro equipamento',
  'Equipment is not selected!': 'Equipamento não está selecionado',
  'Chain & Frame Details': 'Detalhes da Corrente e Chassis',
  'Life(When installed on equipment)': 'Vida (Quando instalado no equipamento)',
  'SMU/HourMeter and Date validation passed!': 'Validade do SMU/Horímetro e data expirada',
  'Date(When installed on equipment)': 'Data (Quando instalado no equipamento)',
  'Equipment SMU/Hourmeter (at install)': 'SMU/Horímetro do Equipamento na Instalação',
  'Review and Save': 'Revisar e Salvar',
  'This will setup components on both sides of the undercarriage the same, you can view and edit sides indivdually if they are different': 'Isto irá configurar ambos os lados do Material Rodante como iguais, você pode visualizar e editar lados individualmente se eles forem diferentes',
  'Chain': 'Corrente',
  'Please add the components which will go on the chain.': 'Por favor, adicione os componentes que irão na corrente',
  'Grouser': 'Garras',
  'Please add the components which will go on the frame.': 'Por favor, adicione os componentes que irão na chassis',
  'Cost': 'Custo',
  'Validation failed': 'Falha na validação',
  'Bushing': 'Bucha da esteira',
  'Budget Life': 'Orçamento para vida',
  'Size': 'Tamanho',
  'Frame': 'Chassis',
  'Idler': 'Roda Guia',
  'Guard': 'Proteção',
  'Track Elongation': 'Prolongamento da Esteira',
  'Carrier Roller': 'Rolo Transmissor',
  'Track Roller': 'Rolo de Esteira',
  'Hours at Install': 'Horas na Instalação',
  'Date at Install': 'Data na Instalação',
  'Equip. SMU/Hourmeter at install': 'SMU/Horímetro do equipamento na instalação',
  'Setup Undercarriage on Equipment': 'Configurar Material Rodante no equipamento',
  'Hrs': 'hrs',
  'Submit': 'Enviar',
  'Unlock': 'Destravar',
  'Validation failed!': 'Falha na validação!',
  'Hours at install': 'Horas Na Instalação',
  'By changing equipment you will lose all your inputs!': 'Ao alterar o equipamento que você vai perder todas as suas entradas!',
  'Validation Passed.': 'Validação Aprovada',
  'Component attached to the system successfully!': 'Componente conectado ao sistema com sucesso!',
  'After you have submitted the data first time round, you are unable to setup components on both sides': 'Depois De Enviar Os Dados Pela Primeira Vez, Você Não Pode Configurar Os Componentes De Ambos Os Lados',
  'The current evaluation of all the equipment you can view based on their last inspection. Filter this data down using the search above.': 'A avaliação atual de todos os equipamento que você vê e baseada na ultima Inspeção. Filtre os dados abaixo utilizando o pesquisar acima.',
  'Eval Overview': 'Classificação Geral',
  'Total count of undercarriage inspections performed on a month by month basis. Filter this data down using the search above.': 'Contagem Total de Inspeções de Materal Rodante realizadas na base mês-a-mês. Filtre os dados abaixo utilizando o pesquisar acima',
  'JobSite is not selected!': 'Local de Trabalho não selecionado',
  'Create new system': 'Criar novo sistema',
  'Update existing': 'Atualização existente',
  'Life(When cerated in inventory)': 'Vida(Quando criado no Inventário)',
  'Setup Undercarriage In Inventory': 'Configurar Material Rodante No Inventário',
  'Model is not selected!': 'Modelo Não Está Selecionado',
  'By changing selection you will lose all your inputs!': 'Você Irá Perder Todas As Entradas Se Alterar A Seleção',
  'Setup new undercarriage': 'Configurar Novo Material Rodante',
  'Previous step validation failed!': 'Validação Do Passo Anterior Falhou',
  'Warning': 'Aviso',
  'Standard Link or Scallop Resistant Link': 'Elo padrão ou elo resistente a vieira',
  'Please select the equipment.': 'Por favor, selecione o equipamento.',
  'You can only change the SMU/Hourmeter, LTD and Date of an existing equipment if there have been NO inspections performed, or actions recorded. If you need to record that a component has been changed, you should record an action against that equipment.': 'Você só poderá muda o SMU/Horímetro, LTD e data de um equipamento existente se não houverem inspeções realizadas ou ações gravadas. Se você precisar registrar que um componente foi alterado, você deve gravar uma ação contra o componente.',
  'Examiner': 'Examinador',
  'Reset': 'Limpar',
  'Evaluation (Worst Side)': 'Avaliação (Pior Cenário)',
  'A': 'A',
  'B': 'B',
  'C': 'C',
  'X': 'X',
  'Start Date': 'Data de início',
  'End Date': 'Data final',
  'Single Flange': 'flange única',
  '0': '0',
  '1': '1',
  '2': '2',
  '3': '3',
  '4': '4',
  '5': '5',
  '6': '6',
  '7': '7',
  '8': '8',
  '9': '9',
  'Manage Inspection Types': 'Gerenciar Tipos de Inspeção',
  'Left Side': 'Lado Esquerdo',
  'Language': 'Idioma',
  'Home Page': 'Pagina Inicial',
  'Currency': 'Moeda',
  'Unit of Measurement': 'Unidade de Medida',
  'Determines how measurements are displayed to you when viewing inspection results, and how a components percentage worn is calculated when you enter a measurement. ': 'Determina como as medições são exibidas quando visualizando resultados de inspeções e como a porcentagem de desgaste de um componente é calculada quando inserido uma medida',
  'Determines how measurements are displayed to you when viewing inspection results, and how a components percentage worn is calculated when you enter a measurement. ,': 'Determina como as medições são exibidas quando visualizando resultados de inspeções e como a porcentagem de desgaste de um componente é calculada quando inserido uma medida',
  'Contact': 'Contato',
  'Full Name': 'Nome Completo',
  'Phone Number': 'Número de Telefone',
  'Address': 'Endereço',
  'Street Address': 'Endereço',
  'Suburb / City': 'Bairro/Cidade',
  'Post Code': 'Código Postal',
  'State': 'Estado',
  'Country': 'País',
  'Dashboard - Fleet Overview': 'Dashboard - Visão Geral da Frota',
  'Millimetres (mm)': 'Milímetros (mm)',
  'Inches (inch)': 'Polegadas (polegadas)',
  'Email Address': 'Endereço de e-mail',
  'This is the email address that all emails, reports, etc. for your account will be sent to.': 'Este é o endereço de e-mail que todos os e-mails, relatórios e etc. da sua conta serão enviados',
  'Username': 'Usuário',
  'This is what you use to sign in to both the web application and the mobile application.': 'Isto é o que vc usará para acessar tanto a página na Web quanto o aplicativo móvel',
  'Change Your Password': 'Mudar Sua Senha',
  'This is the password you use to sign in to both the web application and the mobile application to perform inspections on.': 'Está é a senha que você usará para acessar tanto a página na Web quanto o aplicativo móvel',
  'New Password': 'Nova Senha',
  'Repeat New Password': 'Repita a Nova Senha',
  'Update Password': 'Atualizar Senha',
  'Inspections Due Emails': 'Inspeção de e-mails inativos',
  'Determines whether the sending of Inspections Due Emails is enabled or disabled. ': 'Determina se o envio da inspeção de e-mails inativos está ativada ou desativada',
  'Flange width is 5.24 in. (133 mm), New tread diameter is 30.16 in. (766 mm)': 'Largura da aba é de 5.24 polegadas (133mm). Novo diâmetro do trilho é de 30.16 polegadas (766mm)',
  'Flange width is 5.21 in. (132.4 mm), New Tread diameter is 29.54 in. (750.2 mm), UT Tool only to determine flange wear only': 'Largura da aba é de 5.21 polegadas (132.4mm). Novo diâmetro do trilho é de 29.54 polegadas (750.2mm). Ferramenta ultrassom apenas para determinar o desgaste da falange',
  'Measure across 3 teeth': 'Medida sobre 3 dentes',
  'Flange diameter is 12.28 in. (312 mm)': 'Diâmetro da aba é 12.28 polegadas (312mm)',
  'ForwardTravelHours': 'Horas rercorridas em sentido a frente',
  'ReverseTravelHours': 'Horas rercorridas em Ré',
  'ForwardTravelKms': 'Distância percorrida em sentido a frente (Km)',
  'ReverseTravelKms': 'Distância percorridas em Ré (Km)',
  'TrackSagLeft': 'Tensionameneto da esteira - Lado Esquerdo',
  'TrackSagRight': 'Tensionameneto da esteira - Lado Direito',
  'DryJointLeft': 'Mão de amigo - Lado Esquerdo',
  'DryJointRight': 'Mão de Amigo - Lado Direito',
  'CannonExtLeft': 'CannonExtLeft',
  'CannonExtRight': 'CannonExtRight',
  'ScallopLeft': 'ScallopLeft',
  'ScallopRight': 'ScallopRight',
  'JobsiteNotes': 'Notas de Local de Trabalho',
  'InspectionNotes': 'Notas de Inspeção',
  'Dealer': 'Consecionario',
  'Projected': 'Projetado',
  'Difference': 'Diferença',
  'Low': 'Baixo',
  'High': 'Alto',
  'Medium': 'Médio',
  'Addition Observation Lists': 'Lista De Observações Adicionais',
  'Title': 'Título',
  'Image': 'Imagem',
  'Add Observations': 'Adicionar Observações',
  'Select equipment to create new inspection': 'Selecionar equipamento para criar nova inspeção',
  'Cancel': 'Cancelar',
  'Start Inspection': 'Iniciar Inspeção',
  'Please check your user permissions, Only inspector or super user can create inspections': 'Por favor, verigique suas permissões de usuário. Apenas Inspetores ou Super-Usuários podem criar inspeções',
  'There is no audit history to display.': 'Não há histórico de auditoria para exibir.',
  'Send Report': 'Enviar relatório',
  'Include Quote': 'Incluir Orçamento',
  'Event Time': 'Hora do evento',
  'Change': 'Alterar',
  'Select Email Recipients': 'Selecionar os destinatários de e-mail',
  'Send': 'Enviar',
  'Add Recipient': 'Adicionar Destinatário',
  'An Observation Description is required': 'Uma observação descritiva é necessária',
  'Adding Observation List': 'Adicionando Lista de Observações',
  'Editing Observation List': 'Editando Lista de Observações',
  'Save Observation List': 'Salvar Lista de Observação',
  'Name': 'Nome',
  'Background Colour': 'Cor de fundo',
  'Text Colour': 'Cor do texto',
  'Preview': 'Pré-Visualizar',
  'Save': 'Salvar',
  'Select System / Component': 'Selecionar Sistema/Componente',
  'Action Informations': 'Informações da Ação',
  'Save Action': 'Salvar Ação',
  'Multiple Component Replacement': 'Substituição de Multiplos Componentes',
  'Part Cost': 'Custo da Peça',
  'Labour Cost': 'Custo da Mão de Obra',
  'MiscCost': 'Custos Diversos',
  'Note': 'Nota',
  'Current CMU': 'CMU atual',
  'There is no components on this system, please make sure your undercarriage setup correctly': 'Não há componentes neste Sistema, por favor, certifique-se de ter configurado seu Material Rodante corretamente',
  'Setup new System': 'Configurar Novo Sistema',
  'Refresh Available Replacement List': 'Atualizar Lista de substituições disponíveis',
  'There are no available replacements fits this component': 'Não há substitutos disponíveis que se encaixem nesse componente',
  'Select Swap component': 'Selecione o componente para troca',
  'Labour Cost Option': 'Opções de custo de mão de obra',
  'Misc Cost': 'Custos diversos',
  'Date of Action': 'Data de Ação',
  'Times Re-builded / Re-grousered/ Re-sealed': 'Quantidade de vezes Remontada/Reselada',
  'Total Cost': 'Custo Total',
  'Customer hourly rate': 'Taxa hora do Cliente',
  'Uninstall this at SMU/Hourmeter': 'Desinstalar este na SMU/Horímetro',
  'Action Against': 'Ações contra',
  'Action Histories will be affected by this action': 'Histórico de ações será afetado por esta ação',
  'Disable': 'Desabilitar',
  'Enable': 'Habilitar',
  'Filter By Serial Number': 'Filtrar Por Nº de Série',
  'CMU (Average)': 'CMU (Médio)',
  'Part Number': 'Nº da Peça',
  'CMU (hrs)': 'CMU (horas)',
  '%Worn': '% Desgastado',
  'Action Date': 'Data da ação',
  'Latest Action': 'Última ação',
  'Latest Action Date': 'Data da ultima ação',
  'Action Taken': 'Ação realizada',
  'Date': 'Data',
  'DATE': 'Data',
  'History': 'Histórico',
  'Relocate System': 'Realocar Sistema',
  'System Notes': 'Notas do sistema',
  'Update Notes': 'Atualizar Notas',
  'Relocate To Customer': 'Realocar para Cliente',
  'Relocate To Jobsite': 'Realocar para Local de Trabalho',
  'Account': 'Conta',
  'General': 'Geral',
  'Alerts': 'Alertas',
  'Dashboard - Wear Rate Overview': 'Dashboard - Visão Geral da Taxa de Desgaste',
  'Dashboard - Component Overview': 'Dashboard - Visão Geral do Component ',
  'Hours': 'Horas',
  'Days': 'Dias',
  'Weeks': 'Semanas',
  'Months': 'Meses',
  'Delete': 'Excluir',
  'Additional Observation Lists': 'Listas adicionais de observação',
  'Currently there is no observation list configured for this equipment': 'Atualmente não há nenhuma lista de observação configurado para este equipamento',
  'You are currently missing the': 'Você está faltando o',
  'Your Preferences': 'Suas preferencias',
  'Customer Name': 'nome do cliente',
  'Add': 'Adicionar',
  'Right Side': 'Lado direito',
  'Replace with new Chain and all Components': 'Substitua por uma nova corrente e todos os componentes',
  'Replace with Chain from Inventory': 'Substituir com corrente a partir de estoques',
  'Repairs or Replacements of individual Chain Components': 'Reparação ou substituição de componentes de cadeia individuais',
  'Replace with New Frame including new components': 'Substitua por um novo Quadro incluindo novos componentes',
  'Replace frame from Inventory': 'Substituir quadro de inventário',
  'Repair or Replace individual Frame components': 'Reparar ou substituir componentes quadro individual',
  'Replace Frame Components in Bulk': 'Substituir Componentes de quadro em massa',
  'Update Jobsite': 'Atualização Jobsite',
  'Which jobsite would you like to move this equipment to?': 'Que obra você gostaria de se mover este equipamento?',
  'SMU Reading is required': 'SMU Reading é necessária',
  'New SMU must be greater than previous SMU': 'Novo SMU deve ser maior que SMU anterior',
  'New BCM must be greater than previous BCM': 'Novo BCM deve ser maior que BCM anterior',
  'New Tonnage must be greater than previous Tonnage': 'Novo Tonelagem deve ser maior que Tonelagem anterior',
  'New SMU *': 'Novo SMU/Horímetro *',
  'Old SMU/Hourmeter *': 'SMU/Horímetro anterior*',
  'New SMU/Hourmeter Reading is required': 'Novo SMU / Contador de horas de leitura é necessária',
  'Invalid date: Installation date is before equipment setup date!': 'Data inválida: Data de instalação é antes da data de configuração de equipamentos!',
  'Equipment Setup Date:': 'Equipment Data de Instalação:',
  'Invalid SMU/HourMeter Reading: SMU/HourMeter at install cannot be less than': 'Inválida SMU horímetro Reading /: SMU / horímetro no momento da instalação não pode ser inferior a',
  'Invalid SMU/HourMeter Reading: For the same date SMU/HourMeter has conflict': 'Inválida SMU / horímetro Leitura: Para a mesma data SMU / horímetro tem conflito',
  'Invalid SMU/HourMeter: For': 'Inválida SMU / horímetro: Para',
  'SMU/HourMeter has conflict': 'SMU / horímetro tem conflito',
  'Something is loading please try again after loading completed!': 'Algo está a carregar, por favor tente novamente depois de carregar concluída!',
  'You haven\t recorded any repair costs yet.': 'Você não registramos quaisquer custos de reparação ainda.',
  'Next Inspection Date SMU/Hourmeter': 'Próxima Inspeção Data Smu/Horímetro',
  'Next Inspect Date/SMU': 'Próxima Inspeção Data/SMU',
  'Graph': 'Gráfico',
  'Overview': 'Visão Geral',
  'Right Side - Component Wear Graph and Forecast': 'Lado Direito - o desgaste dos componentes Graph e Previsão',
  'Left Side - Component Wear Graph and Forecast': 'Lado Esquerdo - o desgaste dos componentes Graph e Previsão',
  'Last Inspection Date SMU/Hourmeter': 'Última Inspecção Data SMU / Horímetro',
  'New Thermography Inspection': 'Nuova ispezione Termografia',
  'Overall Inspection Comment': 'Ispezione Commento generale',
  'Thermography Inspection': 'Ispezione Termografia',
  'Jan': 'Jan',
  'Feb': 'Fev',
  'Mar': 'Mar',
  'Apr': 'Abr',
  'May': 'Mai',
  'Jun': 'Jun',
  'Jul': 'Jul',
  'Aug': 'Ago',
  'Sep': 'Set',
  'Oct': 'Out',
  'Nov': 'Nov',
  'Dec': 'Dez',
  'Items per page': 'Itens por página',
  'Description': 'Descrição',
  'Currently there is no observation list configured for this inspection and this equipment': 'Atualmente não há nenhuma lista de observações configurada para esta inspeção e este equipamento',
  'Hours remaining until 100% worn': 'Horas restantes até 100% de desgaste',
  'There is no audit history to display': 'Não há histórico de auditoria registrado',
  'Error': 'Erro',
  'Please release this quote report first': 'Por favor, primeiro libere esta cotação',
  'Add Job Site': 'Adicionar Local de Trabalho',
  'Return to Undercarriage': 'Retornar para Material Rodante',
  'Team Administration ': 'Administrar Equipe',
  'A team can be considered either a customer or a dealership. Each team consists of it’s own group of users who have access to equipment within that team': 'Uma equipe pode ser considerada tanto um cliente quanto um concessionário. Cada equipe consiste do seu próprio grupo de usuários, os quais tem acesso apenas aos equipamentos pertinentes a esta equipe',
  'Add User': 'Adicionar Usuário',
  'Add Customer': 'Adicionar Cliente',
  'Users': 'Usuários',
  'Customers': 'Clientes',
  'Dealerships': 'Concessionários',
  'Filter user table': 'Filtrar tabela de usuários',
  'Full Name ': 'Nome Completo',
  'Team': 'Equipe',
  'Access': 'Tipo de Acesso',
  'More': 'Mais',
  'Request New Model': 'Requisitar Novo Modelo',
  'LTD is the “Life To Date” of the equipment': 'LTD é a “Vida até a Data” do equipamento.',
  'This will generally be the same as the SMU/Hour Meter reading': 'Geralmente é a mesma lida no horímetro',
  'If the meter has been changed, LTD shows the actual machine hours where the SMU/Hour Meter will only show the hours since the meter was installed.': 'Se o horímetro for trocado, a LTF mostrará a quantidade correta de horas do equipamento, enquanto o novo horímetro somente mostrará a quantidade de horas desde quando foi instalado',
  'Date of Reading': 'Data da leitura',
  'Undercarriage History ': 'Histórico do Material Rodante',
  'Select your Equipment ': 'Selecione seu equipamento',
  'Please Select': 'Por Favor Selecione',
  'System S/N': 'Nº de Série do Sistema',
  'Life Lived ': 'Vida Acumulada',
  'Life Remaining (100% Worn': 'Vida Restante (100% de desgaste)',
  'Projected Hours ': 'Horas Projetadas',
  'Both': 'Ambos',
  'Show All Parts': 'Mostrar Todas as Peças',
  'No action taken': 'Nenhuma ação tomada',
  'Never': 'Nunca',
  'Sent': 'Enviado',
  'The PDF report has been emailed to all contacts successfully.': 'O relatório em PDF foi enviado para todos os contatos com sucesso.',
  'Failed to send PDF report. System Error Cannot write the document to memory. Invalid Serial Number Version.': 'Falha ao enviar relatório PDF. Erro do sistema, não pode gravar o documento na memória. Versão do número de série inválida.',
  'Recommendations included in this quote ': 'Recomendações adicionadas nesta cotação.',
  'Distance Unit': 'Unidade de distância',
  'Kilometers (km)': 'Quilómetros (km)',
  'Miles (mi)': 'Miles (mi)',
  'Forward Travel': 'Distância Percorridas em Sentido a Frente',
  'Reverse Travel': 'Distância Percorrida em Ré ',
  'Forward': 'Frente',
  'Reverse': 'Reversa',
  'Create Thermography Inspection': 'Criar Inspeção Termografia',
  'Track Sag (mm)': 'Pista Sag (mm)',
  'Pin Number': 'Número do PIN',
  'Therm L/R': 'Therm G / R',
  'Left Side Additional Component': 'Lado Esquerdo componente adicional',
  'No Side Additional Component': 'Componente adicional Não Lado',
  'Right Side Additional Component': 'Lado Direito componente adicional',
  'Sun': 'Dom',
  'You haven\'t recorded any repair costs yet.': 'Você não registramos quaisquer custos de reparação ainda.',
  'You haven\'t set up any equipment yet.': 'Ele não criou qualquer equipe.',
  'You don\'t have any inspection due for the selection.': 'Não há inspeção pendente para esta seleção.',
  'There are no inspections to display.': 'Não há inspeções para mostrar.',
  'General Inspections': 'Inspeções Gerais',
  'Thermography Inspections': 'Inspeções de Termografia',
  'Both Inspections': 'Ambas Inspecções',
  'Copy to All': 'Copiar para Todos',
  'Copy to Right': 'Copie para a direita',
  'Done': 'Pronto',
  'Update Equipment': 'Atualizar Equipamento',
  'Undercarriage Inspection': 'Inspeção Material Rodante',
  'Temperature Inspection': 'Inspeção Temperatura',
  'This equipment has 2 or more inspections': 'This equipment has 2 or more inspections',
  'Severity': 'Severity',
  'Manage Custom Evaluation': 'Gerenciar Avaliações Personalizadas',
  'Set Evaluation Ranges': 'Definir as Variações de Avaliação',
  'Set Custom Evaluation Ranges': 'Personalizar as Variações de Avaliação',
  'Select Level': 'Selecionar Nível',
  'Please select individual machine from the search field above.': 'Por favor, selecione o equipamento no campo de busca acima.',
  'Equipment Level Selected': 'Nível do Equipamento Selecionado',
  'Select Dealer': 'Selecionar Concessionário',
  'Select Jobsite': 'Selecionar Local de Trabalhoe',
  'A Range': 'Variação de A',
  'B Range': 'Variação de B',
  'C Range': 'Variação de C',
  'X Range': 'Variação de X',
  'Track Shoes': 'Sapatas',
  'Track Rollers': 'Roletes Inferiores',
  'Tumblers': 'Roda Motriz',
  'Front Idlers': 'Rodas Guias Frontais',
  'Rear Idlers': 'Rodas Guias Traseiras',
  'Crawler Frame Guide': 'Guia do Quadro de Esteira Rolante',
  'A machine with this Serial No and Unit No combination already exists in your Dealer Group. Please contact your Dealer group administrator to be given access to this machine': 'Um equipamento com esta combinação de Nº de Série e Nº de Unidade já existe no seu Grupo de Concessionário. Por favor, contate seu administrador do grupo de concessionário para receber acesso a este equipamento.',
  'Thermal Images': 'Imagens Térmicas',
  'UT Equivalent': 'Equivalente em US',
  'Custom Evaluation ranges do not currently apply to Rope Shovels.': 'Custom Evaluation ranges do not currently apply to Rope Shovels.',
  'Additional Unit Number': 'Código Adicional',
  'Serial/Unit Search': 'Procurar por Número do Equipamento/Série',
  'Recalculate & Save': 'Recalculate & Save',
  'UC Default Setup Type': 'Instalação Padrão do Material Rodante',
  'Undercarriage ': 'Material Rodante',
  'Default Form Type': 'Formulário Padrão',
  'Display Maintenance Inspection': 'Display da Inspeção de Manutenção',
  'Advanced': 'Avançado',
  'Basic': 'Básico',
  'UC Dashboard': 'Dashboard do MR',
  'Setup ': 'Setup',
  'New Inspections': 'Novas Inspeções',
  'Find Inspections': 'Encontrar Inspeções',
  'Component Performance': 'Performance do Componente',
  'Fleet Forecast': 'Previsão da Frota',
  'Undercarriage Setup': 'Setup do Material Rodante',
  'Setup UC in Inventory': 'Setup do MR no Inventário',
  'Search WRSE': 'Procurar WRSE',
  'New Workshop Repair': 'Novo Workshop de Reparação',
  'Field Inspections': 'Inspeções a Campo',
  'Search Digital Forms': 'Procurar Formulários Digitais',
  'Form Administration': 'Formulário Administrativo',
  'New Equipment': 'Novo Equipamento',
  'New Implement ': 'Novo Implemento',
  'Copy Implement ': 'Copiar Implemento',
  'Modify Exisiting Implement ': 'Modificar Implemento Existente',
  'Training': 'Treinamento',
  'Help Centre': 'Central de Ajuda',
  'Whats New': 'O que há de novo',
  'Action History': 'Histórico de Ações',
  'Depth Guage': 'Medidor de Profundidade',
  'You haven\'t Recoreded any repair costs yet': 'Não possui Custos de Reparos Salvos',
  'Manage Training': 'Gerenciar o treinamento',
  'Create Categories': 'Criar Caterogias',
  'Create Questions': 'Crie perguntas',
  'Load Slides': 'Carregar slides',
  'Administrators - Webapp': 'Administradores - Webapp',
  'Administration Services': 'Serviços de Administração',
  'Managing Digital Form Inspections ': 'Gerenciando Inspeções de Formulários Digitais',
  'Implements and Structures': 'Implementos e Estruturas',
  'Inspectors': 'Inspetores',
  'Installing the Mobile App': 'Instalando o aplicativo móvel',
  'Undercarriage Component Inspection Methods': 'Métodos de inspeção do componente do material rodante',
  'Dozer Inspections': 'Inspeções de buldôzer',
  'Rope Shovel Inspections': 'Inspeções de escavadeira de corda',
  'Daily Inspections': 'Inspeções Diárias',
  'Structual Inspections': 'Inspeções Estruturais',
  'Magnetic Plugs': 'Plugues Magnéticos',
  'Inerpreters': 'Intérpretes',
  'Interpreting Undercarriage Inspections - Webapp': 'Interpretando inspeções de material rodante - Webapp',
  'Supervisors': 'Supervisores',
  'Releasing Inspections': 'Liberando Inspeções',
  'Team Admin, Access, and Permission': 'Administrador de equipe, acesso e permissão',
  'Managing Customers, Jobsites, and Users': 'Gerenciando clientes, canteiros de obras e usuários',
  'Creating Digital Forms': 'Criação de formulários digitais',
  'Implements, Structures & Templates': 'Implementos, estruturas e modelos',
  'Creating new Implements and Structures': 'Criação de novos implementos e estruturas',
  'Copying Implements & Structures': 'Copiando Implementos e Estruturas',
  'Modifying Implements & Structures': 'Modificando Implementos e Estruturas',
  'Installing IOS App': 'Instalando o aplicativo IOS',
  'Installing Android App': 'Instalando o aplicativo Android',
  'Installing Android App from Webapp': 'Instalando o Android App a partir do Webapp',
  'Cannon Extension': 'Extensão de canhão',
  'Dry Joints Identification': 'Identificação de juntas secas',
  'Scalloping Measurement on a Link': 'Medição de recorte em um link',
  'Links': 'Links',
  'Shoes': 'Sapato',
  'Idlers': 'Idlers',
  'Setup Equipment with Undercarriage - Web App': 'Equipamento de configuração com material rodante - aplicativo da Web',
  'Setup Equipment with Undercarriage - Mobile App Offline': 'Configurar equipamento com material rodante - aplicativo móvel off-line',
  'Setup Equipment with Undercarriage - Mobile App': 'Equipamento de configuração com material rodante - aplicativo móvel',
  'Load Machines onto Mobile App': 'Carregar máquinas no aplicativo móvel',
  'Perform an Inspection - Mobile App': 'Executar uma inspeção - aplicativo móvel',
  'Syncing and Exporting an Inspection - Mobile app': 'Sincronizando e exportando uma inspeção - aplicativo móvel',
  'Creating New Equipment - Webapp': 'Criando Novo Equipamento - Webapp',
  'Chain and frame details - Webapp': 'Detalhes da corrente e moldura - Webapp',
  'Components - Webapp': 'Componentes - Webapp',
  'Load A Rope Shovel Onto iOS Device': 'Carregar uma pá de corda no dispositivo iOS',
  'Rope Shovel Inspection - Mobile App': 'Inspeção de escavadeira de corda - aplicativo móvel',
  'Syncing and Exporting Inspections': 'Sincronizando e exportando inspeções',
  'Loading a daily inspection form': 'Carregando um formulário de inspeção diária',
  'Questions overview': 'Visão geral das perguntas',
  'Simple answers and adding images': 'Respostas simples e adicionar imagens',
  'Using flags and unanswered questions': 'Usando sinalizadores e perguntas sem resposta',
  'Exporting the form': 'Exportando o formulário',
  'Syncing, completing, and troubleshooting': 'Sincronização, conclusão e solução de problemas',
  'Loading a structural inspection form': 'Carregando um formulário de inspeção estrutural',
  'Syncing, completing and troubleshooting': 'Sincronização, conclusão e solução de problemas',
  'Loading a magnetic plug form': 'Carregando um formulário de plugue magnético',
  'Question overview': 'Visão geral da pergunta',
  'Using flags': 'Usando sinalizadores',
  'What is Interpretation': 'O que é interpretação',
  'Opening the Interpretation Screen': 'Abrindo a tela de interpretação',
  'Making Changes': 'Fazendo mudanças',
  'Adding Recommendations': 'Adicionando Recomendações',
  'Adding Interpretation Comments': 'Adicionar comentários de interpretação',
  'Releasing the inspection': 'Liberando a inspeção',
  'Rope Shovel Undercarriage Interpretation': 'Interpretação do material rodante da escavadeira a cabo',
  'Generating the Report': 'Gerando o Relatório',
  'No Undercarriage components setup': 'Sem configuração de componentes do subchassi.',
  'Enable Tracking by Distance Travelled': 'Ativar rastreamento por distância percorrida',
  'Equipment not in Use': 'Equipamento não em uso',
  'Distance': 'Distância',
  'Propel': 'Deslocamento',
  'Propel %': 'Deslocamento %',
  'Average Usage': 'Média de Utilização',
  'Avg Usage': 'Média de Utilização',
  'Residual Hrs': 'Horas Remanescentes',
  'Replacement Date': 'Data de Troca',
  'Work Order#': 'Nº da Ordem de Serviço',
  'Work Order': 'Nº da Ordem de Serviço',
  'B/Turn%': '% de Desgaste da Bucha Girada',
  'Res. Life': 'Vida Residual até',
  'Projected 100%': 'Vida Projetada até 100%',
  'Projected 120%': 'Vida Projetada até 120%',
  'Frame Condition': 'Condições do Chassi',
  'Equipment DOE at Install': 'Distância Percorrida do Equipamento na Instalação',
  'Distance Budget': 'Planejamento de Distância Percorrida',
  'Frame Cost': 'Custo do Chassi',
  'Frame Repair Cost': 'Custo de Reparo do Chassi',
  'Frame Configuration': 'Configuração do Chassi',
  'Cannon Type': 'Tipo do Esticador',
  'Residual Life based on 100% budgeted hours/propel hours': 'Vida útil residual baseada em 100% das horas orçadas/horas de propulsão',
  'Residual Life based on 120% budgeted hours/propel hours': 'Vida útil residual baseada em 120% das horas orçadas/horas de propulsão',
  'Projected Life based on 100% budgeted hours/propel hours': 'Vida útil projetada com base em 100% das horas orçadas/horas de propulsão.',
  'Projected Life based on 120% budgeted hours/propel hours': 'Vida útil projetada com base em 120% das horas orçadas/horas de propulsão.',
  'Click to edit condition': 'Clique para editar a condição',
  'Click to edit': 'Clique para editar',
  'Click to edit Component': 'Clique para editar o componente',
  'UC Inspection': 'Inspeção do MR',
  'Maintenance Inspection': 'Inspeção de Manutenção',
  'End of Life Inspection': 'Inspeção de Fim de Vida',
  'Last % Worn Forecasted': 'Projeção do % do Último Desgaste',
  '% Worn Today': '% Desgaste Atual',
  'Distance Difference': 'Diferença de Distância Percorrida',
  '%Worn (heading)': 'Desgaste (Cabeçalho)',
  'Inspection Type': 'Tipo de inspeção',
  'AVG Daily Usage': 'Média de Utilização Diária',
  'Load More': 'Carregar Mais',
  'Worn Percentage': 'Percentual de Desgaste',
  'Component Hours': 'Horas do Componente',
  'Last Insp. % Worn': 'Última inspeção % de desgaste',
  'Display Columns for': 'Mostrar colunas por?',
  'Action Type': 'Tipo de Ações',
  'Side': 'Lado',
  'Component Type': 'Tipo de Componente',
  'REFRESH': 'Atualizar',
  'L/H Chain CMU': 'Horas acumuladas dos componentes do lado esquerdo',
  'R/H Chain CMU': 'Horas acumuladas dos componentes do lado direito',
  'Action Desc': 'Descrição da Ação',
  'Entered By': 'Informações De',
  'Entered Date': 'Data inserida',
  'Total': 'Total',
  'TOTAL': 'Total',
  'Rolling': 'Rodante',
  'Stock Cost': 'Custo do Material',
  'Rolling Stock Cost': 'Custo do Material Rodante',
  'Chain Cost': 'Custo da Corrente',
  'Segment Cost': 'Custo da Roda Motriz',
  'Running Cost': 'Custo de Operação',
  'Cost/Hour': 'Custo por Hora',
  'Cost/Km': 'Custo por Km',
  'Propel Hrs': 'Horas de Deslocamento',
  'Reverse Dist. %': '% de Reversão Percorrida',
  'Total Dist.': 'Distância Total',
  'Add Recommendation': 'Adicionar Recomendação',
  'Save Commment': 'Salvar Comentário',
  'Duplicate Inspection': 'Inspeção Duplicada',
  'Refresh linked Inspection': 'Atualizar Inspeção vinculada',
  'Both Side': 'Ambos os Lados',
  'Forecast': 'Projeção',
  'Edit Component': 'Editar Componente',
  'Add Component': 'Adicionar Componente',
  'Inspection Id': 'ID da Inspeção',
  'Enter text here...': 'Digite o texto aqui...',
  'Quotes & Recommendations': 'Cotações e Recomendações',
  'Equaliser Bar Type': 'Tipo de barra de equalização',
  'Toe Out': 'Toe Out',
  'Straight': 'Reto',
  'Res. DOC': 'Distância residual no componente',
  'Edit Component Type': 'Editar Tipo de Componente',
  'Answer': 'Resposta',
  'Hourmeter': 'Horímetro',
  'Select Type': 'Selecionar Tipo',
  'Select Status': 'Selecionar Status',
  'Include Inventory on Equipment': 'Inclusão do Inventário no Equipamento',
  'Include Related Models': 'Inclusão dos Modelos Relativos',
  'Exclude "Scrap"': 'Excluir "Sucata"',
  'Task List': 'Lista de Tarefas',
  'Chain to Inventory': 'Corrente para o Inventário',
  'Frame to Inventory': 'Chassi para o Inventário',
  'Idler to Inventory': 'Roda Guia para Inventário',
  'Inventory Report': 'Relatório de Inventário',
  'Serial#': 'Nº de Série',
  'Equip unit#': 'Nº do Equipamento',
  'Condition / Hour on Components / Action done': 'Condição / Horas Acumuladas no Componente / Ações Realizadas',
  '% Link': '% Link',
  'Action': 'Ações',
  '% Bush': '% Bucha',
  'Warning message': 'Advertência',
  'Images': 'Imagens',
  'Initial Cost': 'Custo Inicial',
  'Repair Cost': 'Custo de Reparo',
  'Budget': 'Orçamento',
  'Dist. Budget': 'Distribuição do Orçamento',
  'Dist. Budget (Km)': 'Distribuição do Orçamento',
  //Mohit
  //Translation done by mohit portegesse
  'Choose a date': 'Escolha uma data',
  'Select Asset': 'Selecionar Ativo',
  'Component Criticality': 'Criticidade do Componente',
  'Select Family': 'Selecionar Família',
  'Component List': 'Lista de Componentes',
  '% Contribution to UC Eval': '% de Contribuição para Avaliação do MR',
  'Fazer': 'Marca',
  'Data de Inspecção': 'Data da Inspeção',
  'No Action': 'Sem Ações',
  'Certo': 'Direito',
  'cadeia de série': 'Número da Corrente',
  'série do quadro': 'Número do Chassi',
  'Frame style': 'Estilo da moldura',
  'arbusto virado': 'Pino e Bucha Girado',
  'Unidade#': 'Nº da Frota',
  'DG': 'Profundímetro',
  'R': 'Régua',
  'UK': 'Ferramenta Desconhecida',
  'Meter Unit Reading': 'Leitura do Horímetro',
  'Site de Trabalho': 'Local de Trabalho',
  'Measurement Point Description': 'Descrição do Ponto de Medição',
  '% Contribution to Compart': '% de Contribuição para Compart',
  'Measurement Point List For': 'Lista de Pontos de Medição Para',
  'User Contact': 'Contato do Usuário',
  'Contains': 'Contém',
  'Add New Customer': 'Adicionar Novo Cliente',
  'User Contact Details': 'Detalhes do Contato do Usuário',
  'Customer Level': 'Nível de Usuário do Cliente',
  'Job Site Level': 'Nível de Local de Trabalho',
  'Equipment Level': 'Nível do equipamento',
  'Email': 'E-mail',
  'Health': 'Saúde',
  'Under Carriage': 'Material Rodante',
  'Service': 'Serviço',
  'Please Select a Customer': 'Por favor, selecione um cliente',
  'Update Selected': 'Actualizar seleccionado',
  'Delete Selected': 'Eliminar seleccionado',
  'Select Customer To Add': 'Selecione o Cliente Para Adicionar',
  'Close': 'Fechar',
  'Select Job Site(S) To Add': 'Selecione o(s) Local(is) de Trabalho para Adicionar',
  'Equipments': 'Equipamentos',
  'Select User To Add': 'Selecionar Usuário Para Adicionar',
  'Select User(S) To Add': 'Selecionar Usuário(s) Para Adicionar',
  'Add New User': 'Adicionar Novo Usuário',
  'Reload': 'Recarregar',
  'Export All': 'Exportar Tudo',
  'Customer Contact Details': 'Detalhes do Contato do Cliente',
  'Customer Contact': 'Contato do Cliente',
  'Inspection Types': 'Tipo de Inspeção',
  'Please select a model first': 'Por favor selecione o modelo primeiro',
  'An Inspection Name is required': 'Um nome de inspeção é obrigatório',
  'Inspection': 'Inspeção',
  'Manage': 'Gerenciar',
  'Inspection Name': 'Nome da Inspeção',
  'There is no inspection types configured for ': 'Não há tipos de inspeção configurados para ',
  'Select Additional Observation Level': 'Selecionar Nível de Observações Adicionais',
  'Additional Observation Constraint Filter': 'Filtro de Observações Adicionais',
  'Adding Additional Observation List': 'Adicionando Lista de Observações Adicionais',
  'Editing Additional Observation List': 'Editando Lista de Observações Adicionais',
  'Select Answer Type': 'Selecionar tipo de resposta',
  'Additional Observation List On Customer': 'Lista de Observações Adicionais Sobre o Cliente',
  'Add Dealership': 'Adicionar Concessionário',
  'Add Dealer Group': 'Adicionar Grupo de Concessionário',
  'Job Sites': 'Local de Trabalho',
  'Dealer Group': 'Grupo de Concessionários',
  'Undercarriage Inspections Due Emails': 'E-mails com avisos sobre inspeções da parte inferior da carroceria',
  'Daily Inspections Due Emails': 'E-mails de aviso de inspeções diárias',
  'Alerting a user of any overdue Digital Inspections which have not been completed after 40 hours. ': 'Alerta o usuário sobre quaisquer inspeções digitais em atraso que não tenham sido concluídas após 40 horas. ',
  'PIP Emails': 'PIP e-mails',
  'Receive email alerts for PIP’s  ': 'Receba alertas por e-mail sobre PIPs  ',
  'DFI Emails': 'DFI e-mails',
  'Receive email alerts for DFI’s  ': 'Receba alertas por e-mail para DFIs  ',
  'Leave Approval Emails': 'e-mails de aprovação',
  'NSW': 'NSW',
  'WA': 'WA',
  'Alerts on the Dashboards': 'Alertas nos Painéis',
  'When the box is ticked the alerts will show. ': 'Quando a caixa estiver marcada, os alertas serão exibidos. ',
  'User Preferences': 'Preferências do Usuário',
  'Undercarriage User Type': 'Tipo de usuário do trem de pouso',
  'UC Dashboard Settings': 'Configuração do Painel de MR',
  'UC Component Inspection Order': 'Ordem de Inspeção de Componentes',
  'UC Multiple Measurements': 'Múltiplas Medições do MR',
  'UC Equipment Conditions': 'Condições do MR do Equipamento',
  'UC Inspection & Jobsite Comments Display': 'Tela de Comentários da Inspeção do MR & Local de Trabalho',
  'Undercarriage Forecast - % Worn Today': 'Projeção do Material Rodante - % de Desgaste Atual',
  'GET Dashboard Tasks Show/Hide': 'Mostrar/Ocultar Tarefas do Painel GET',
  'Enable Replace Existing tab': 'Ative a guia "Substituir existente"',
  'UC Equipment Detail Settings': 'Configurações de Detalhes do Equipamento UC',
  'Please refresh the page to see this change': 'Por favor, atualize a página para ver esta alteração',
  //
  //Aditya
  'Forecast Selection': 'Configuração de Projeção',
  'Preset Forecast Wear Rates': 'Taxas de Desgaste de Previsão Predefinidas',
  'Usage (Hrs)': 'Uso (Horas)',
  'Latest SMU/DOE': 'Último SMU/DOE',
  'Average From Last 3 Inspections': 'Média das Últimas 3 Inspeções',
  'Show dates for 100% Worn': 'Mostrar datas para 100% de desgaste',
  'Preset Averages': 'Médias Predefinidas',
  'Safety Factor': 'Fator de Segurança',
  'SMU:': 'SMU:',
  'Show dates for 120% Worn': 'Mostrar datas para 120% de desgaste',
  'Winter': 'Inverno',
  'Summer': 'Verão',
  'Shoulder': 'Ombro',
  'Other': 'Outro',
  'Model Level': 'Nível do Modelo',
  'Machine Level': 'Nível da Máquina',
  'Last 4th Historical Inspection': '4ª Última Inspeção Histórica',
  'DOE:': 'DOE:',
  'Forecast-Settings': 'Configurações de Previsão',
  'Forecast Method': 'Método de Previsão',
  'Forecast Future Service': 'Previsão de Serviço Futuro',
   'Next PM Service': 'Próximo Serviço de MP',
  '2nd PM Service': '2º Serviço de MP',
  'Floating Date': 'Data de Projeção Dinâmica',
  'Floating Date 2': 'Data de Projeção Dinâmica 2º',
  'None': 'Nenhum',
  'Latest SMU': 'Último SMU',
  'Save/Refresh': 'Salvar/Atualizar',
  'Prior Inspect 3': '3ª Inspeção Anterior',
  'Prior Inspect 1': '1ª Inspeção Anterior',
  'Prior Inspect 2': '2ª Inspeção Anterior',
  'Last Inspect': '1ª Última Inspeção',
  'Avg CMU': 'CMU Médio',
  'Per % Wear': 'Por % de Desgaste',
  'Avg DOC': 'DOC Médio',
  'Date 100% Worn': 'Data de 100% de Desgaste',
  'Date 120% Worn': 'Data de 120% de Desgaste',
  'Last Inspection': 'Última Inspeção',
  'Show Last 4th Historical Inspection': 'Mostrar a 4ª Última Inspeção Histórica',
  'Distance Ratio': 'Relação de Distância',
  //
  'Fleet Reporting': 'Relatório da Frota',
  'Pre and Post Hire Report': 'Relatório de Evolução Pré e Pós Instalação',
  'Email Log': 'Log de e-mail',
  'Advances Forecasting': 'Projeções Avançadas',
  'Inspection Data Export': 'Exportação de Informações das Inspeções',
  'Report Selection': 'Selecionar Relatório',
  'Inspected Machines': 'Equipamentos Inspecionados',
  'Identified Issues': 'Identificação de Problemas',
  'Track Tensions': 'Tensão da Corrente',
  'Undercarriage Configuration': 'Configuração do Material Rodante',
  'Dealer Name': 'Nome do Concessionário',
  'Filter by Component Details': 'Filtrar por Detalhes dos Componentes',
  'Jobsite Type': 'Tipo do Local de Trabalho',
  'Only components currently fitted to equipment': 'Somente os componentes instalados no Equipamento.',
  'Export to Excel': 'Exportar para o Excel',
  'Component Performance Details': 'Detalhes de Performance dos Componentes',
  'Averages': 'Média',
  'Part': 'Peça',
  'Last Worn': 'Último Desgaste',
  'Last Eval': 'Última Avaliação',
  'Projected 100% Hrs': 'Vida Projetada até 100%',
  'Projected 120% Hrs': 'Vida Projetada até 120%',
  'Date Removed': 'Data da Remoção',
  'Cost Per Hour': 'Custo por Hora',
  'AVG': 'Média',
  'Start date': 'Data de Início',
  'Interval': 'Intervalo',
  'Serial No./ Unit No.': 'Nº de Série/Nº da Unidade',
  'Totals Only': 'Somente Totais',
  'Totals & Details': 'Totais & Detalhes',
  'OEM Part#': 'Código da Peça Original',
  'MFR Part#': 'Número da Peça do Fabricante',
  'Select equipment': 'Selecionar Equipamento',
  'Meter reading': 'Leitura do Horímetro',
  'Life to Date': 'Horímetro atual do equipamento',
  'Setup date': 'Data da Configuração',
  'Download report': 'Download do Relatório',
  'Add Inspection and Comments': 'Inserir Inspeções e Comentários',
  'log sent': 'Envio de log',
  'Report Number': 'Número do relatório',
  'Perform Search': 'Procurar',
  'Report No': 'Número do relatório',
  'Log Date': 'Data de registro',
  'Sent to Address': 'Enviar para o endereço de e-mail',
  'Selection Criteria for Filtering': 'Seleção de Critérios para Filtrar',
  'Select Brand': 'Selecionar Marca',
  'Select Year': 'Selecionar Ano',
  'Select Month': 'Selecionar Mês',
  'Show and hide columns': 'Mostrar e Ocultar Colunas',
  'Saved Scenarios for Forecasting': 'Cenários para Projeção Salva',
  'Segments': 'Segmentos da Roda Motriz',
  'Averages for selected data': 'Médias para dados selecionados',
  'Scenario': 'Cenários',
  'Update selection': 'Selecionar Atualização',
  'export': 'Exportar',
  'Machine Inspection Data': 'Informação de Inspeção do Equipamento',
  'Average Daily Hrs': 'Médias de Horas Diárias',
  'Average Daily Dist': 'Médias de Distância Percorrido',
  'Inspection Events': 'Eventos das Inspeções',
  'Risk Rating': 'Classificação do Risco',
  'Inspection Comments': 'Comentários da Inspeção',
  'Recommended Actions': 'Ações Recomendadas',
  'Your Inspection ID': 'Tipo de Inspeção',
  'Measured Data Part Wear % per Component': 'Informação da Medição de Desgaste por Componente',
  'Bush Turned Left': 'Bucha Esquerda Girada',
  'Bush Turned Right': 'Bucha Direita Girada',
  'Additional unit number': 'Código Adicional',
  'BCM at setup': 'Banco Metro Cúbico na Configuração',
  'Tonnage at setup': 'Capacidade de Carga na Configuração',
  'Choose file': 'Escolher Arquivo',
  'No file chosen': 'Nenhum Arquivo Escolhido',
  'Usage Distance (km) per day': 'Distância Utilizada (km) por dia',
  'How often will you be inspecting this equipment?': 'Qual a periodicidade que o equipamento será inspecionado?',
  'You can also set some additional details': 'Você pode inserir informações adicionais, embora isso seja opcional.',
  'Date at install (chain)': 'Data de Instalação (Corrente)',
  'SMU on Equipment at Install': 'Horímetro no Equipamento na Instalação',
  'Historical Hours on Chain at Install': 'Acúmulo de Horas no Chassis desde a Instalação',
  'Date at Install (Frame)': 'Data de Instalação (Chassi)',
  'Budget life(Hrs)': 'Planejamento de Vida (horas)',
  'Budget Distance(Km)': 'Planejamento de Distância Percorrida (km)',
  'Historical Hours on Frame at Install': 'Acúmulo de Horas no Chassi desde a Instalação',
  'Date of Setup': 'Data de Configuração',
  'Historical Hours on Chain at Setup': 'Acúmulo de Horas Trabalhadas da Corrente desde a Instalação',
  'Historical Distance on Chain at Setup': 'Acúmulo de Distância Percorrida da Corrente desde a Instalação',
  'Chain Components': 'Componentes da Corrente',
  'Show Parts Ids': 'Mostrar Códigos das Peças',
  'Job': 'Trabalho',
  'Cleaner Holes': 'Perguntar ao Caio',
  'UnKnown': 'Desconhecido',
  'Disabled': 'Desativado',
  'Edit Observation': 'Editar Observações',
  'Update Equipment Status': 'Atualização do Status do Equipamento',
  'Select Equipment Status': 'Selecionar Status do Equipamento',
  'Update': 'Atualização',
  'Search WSRE': 'Procurar Oficina de Reparo',
  'Job Status': 'Status do Trabalho',
  'Temperature Inspections': 'Inspeção de Temperatura',
  'CRACK VIEW': 'Visualização de rachaduras',
  'Search Results': 'Procurar Resultados',
  '# of Cracks': '# de rachaduras',
  'Total Crack Length': 'Comprimento total da fissura',
  'Average Crack Length': 'Comprimento Médio da Rachadura',
  'Fixed': 'Consertado',
  'Hide Favorites': 'Ocultar Favoritos',
  'Create Favorite': 'Criar Favoritos',
  'Select family': 'Selecionar Família',
  'Select asset Make': 'Selecionar a Marca do Ativo',
  'Select Job site': 'Selecionar Local de Trabalho',
  'Select Male': 'Selecionar Marca',
  'Select Component Type': 'Selecionar o Tipo de Componente',
  'Select Asset Type': 'Selecionar o Tipo do Ativo',
  'Asset Serial Number': 'Número de Série do Ativo',
  'Select Asset Definition': 'Selecionar a Definição do Ativo',
  'Select Serial Number': 'Selecionar o Número de Série',
  'Select Alt. Number': 'Selecione Alt. Número',
  'Template': 'Padrão',
  'All': 'Tudo',
  'Rest': 'Limpar',
  'Serch': 'Procurar',
  'Asset View': 'Visualização do Ativo',
  'Asset Location History': 'Histórico de Localização do Ativo',
  'Crack View': 'Visualização de rachaduras',
  'Asset definition': 'Definição do Ativo',
  'Alt. Serial': 'Alt. Número',
  'Imp. Serial': 'Imp. número de série',
  'Life': 'Vida',
  'Residual': 'Remanescente',
  'Total Life': 'Vida Total',
  'Replace Date': 'Data de Troca',
  'Warranty Status': 'Status da Garantia',
  'Build No': 'Construir não',
  'Next Inspect': 'Próxima Inspeção',
  'Flag': 'Bandeira',
  'Please select the customer and job site': 'Por favor selecione o Cliente e o Local de Trabalho onde o Equipamento está localizado',
  'What is the earliest known SMU': 'Qual é a SMU mais antiga conhecida e a data de leitura desse equipamento?',
  'BCM at Setup': 'Banco Metro Cúbico na Configuração',
  'Tonnage at Setup': 'Capacidade de Carga na Configuração',
  'Tons': 'Tons',
  'Choose files': 'Escolher Arquivos',
  'No Files Chosen': 'Nenhum Arquivo Escolhido',
  'Hours of Use': 'Horas de Utilização',
  'Per Day': 'Por dia',
  'Tues': 'Ter',
  'Thurs': 'Qui',
  'Advanced Forecasting': 'Projeções Avançadas',
  'Now that you have setup your equipment': 'Agora que você configurou seu equipamento, precisa configurar os implementos antes de começar a registrar as inspeções.',
  'Setup Implements for This Equipment': 'Configurar Implementos para este Equipamento',
  'New Implement': 'Novo Implemento',
  'Customer and Jobsite Selection': 'Seleção do Cliente e Local de Trabalho',
  'Add to Equipment': 'Adicionar ao Equipamento',
  'Jobsite Inventory': 'Local de Inventário',
  'Equipment SMU at initial Install': 'Horímetro do Equipamento na Instalação Inicial',
  'Implement Definition': 'Definição do Implemento',
  'Select Asset Model': 'Selecionar o Tipo do Modelo',
  'Implement Capacity': 'Capacidade de Carga do Implemento',
  'Select GET Type': 'Selecionar o Tipo de GET',
  'Implement Details': 'Detalhes do Implemento',
  'Implement Serial Number': 'Número de Série do Implemento',
  'Additional Serial #': 'Nº de Série Adicional',
  'Implement make': 'Marca do Implemento',
  'Implement Budget': 'Planejamento do Implemento',
  'Implement Tons at setup': 'Implemento toneladas na configuração',
  'Implement Setup Date and Hours': 'Data e Hora da Configuração do Implemento',
  'Hours on Implement at setup': 'Horas Acumuladas do Implemento na Configuração',
  'Implement Cost': 'Custo do Implemento',
  'Implement Purchased Cost': 'Custo de Aquisição do Implemento',
  'Save changes & Go To next': 'Salvar Alterações e Seguir',
  'Add implement Image': 'Inserir Imagem do Implemento',
  'Advanced Implement Copying': 'Cópia Avançada de Implementos',
  'Source Details': 'Procurar Detalhes',
  'Please select the customer and job site where the EXISTING implement is located': 'Por favor selecione o Cliente e o Local de Trabalho onde a existência do Implemento está localizado para cópia',
  'Is the EXISTING implement on an equipment, or in inventory ?': 'O implemento existente está no equipamento, ou no inventário?',
  'Destination Details': 'Detalhes do Destino',
  'Please select the customer and job site where the DESTINATION implement is located': 'Por favor selecione o Cliente e o Local de Trabalho onde o Implemento de destino está localizado',
  'Is the DESTINATION implement on an equipment, in inventory or exisiting implement?': 'O DESTINO está implementado em um equipamento, em inventário ou em implemento existente?',
  'Select Implement(s) to be copied': 'Selecionar o Implemento a ser Copiado',
  'Select Implement': 'Selecionar o Implemento',
  'Imp Type:Serial': 'Tipo do Imp : Série',
  'Implement Type': 'Tipo do Implemento',
  'New Serial No.': 'Novo Nº de Série',
  'Equipment SMU at Setup': 'Horímetro do Equipamento na Configuração',
  'Budget Hours': 'Planejamento de Horas',
  'Purchased Cost': 'Custo de Aquisição',
  'Copied': 'Copiado',
  'Copy Selected': 'Cópia Selecionada',
  'Modify Asset': 'Alterar Ativo',
  'Add Implement Image': 'Inserir Imagem do Implemento',
  'Asset Definition Setup': 'Configurar Definições do Ativo',
  'Input Asset Definition': 'Entrada de Definição do Ativo',
  'Input Model #': 'Entrada do Modelo #',
  // 'reset': 'Limpar',
  // 'Add New': 'Inserir Novo',
  'Asset/System Type': 'Tipo do Sistema/Ativo',
  'Asset Definition': 'Definição do Ativo',
  'Model #': 'Nº do Modelo',
  'PDF Formats to be used': 'Formato em PDF pode ser usado',
  'Manage Observation Lists': 'Gerenciar Listas de Observações',
  'Select a Customer': 'Selecione o Cliente',

  'Serial/ Unit Search': 'Procurar pelo Nº do Equipamento/Série',
  'Stautus': 'Status',
  'Off-Highway': 'Fora de Estrada',
  'Tempreture Inspections': 'Inspeção de Temperatura',
  'UC planner': 'Planejador de MR',
  'Display options': 'Opções de exibição',
  'Columns': 'Colunas',
  'Dates': 'Datas',
  'Legend': 'Legenda',
  'tasks': 'Tarefas',
  'Enter SMU/dates': 'Digitar Horímetro/Data',
  'Create favorite': 'Criar Favorito Procurar',
  'February': 'Fevereiro',
  'Enter Date For SMU': 'Digitar Data para SMU',
  'Favorite': 'Favoritos',
  'Last Known': 'Data do Último Horímetro ou Distância Conhecido',
  'Enter Date': 'Digitar Data',
  'Enter SMU': 'Leitura do Horímetro',
  'Equipment Serial No/Unit No': 'Número de Série ou Unidade do Equipamento',
  'Select All': 'Selecionar todos',
  'Recommended Action': 'Ações Recomendadas',
  'Oldest Date': 'Data mais antiga',
  'Highest Severity': 'Severidade Máxima',
  'Earliest': 'Horímetro mais antigo do Equipamento',
  'Hours Gained': 'Horas de Vida pós ação',
  'Adjust all staus for equipment': 'Ajustar todos os Status para o Equipamento',
  'Adjust all status for Equip': 'Ajustar todos os Status para o Equipamento',
  'Action Search': 'Pesquisa de Ação',
  'Favorites': 'Favoritos',
  'Download': 'Baixar',
  'Preparing Planner': 'Preparando Planejador',
  'Generate': 'Gerar',
  'SMU & PMU Service': 'Serviço SMU & PMU',
  'No data available': 'Nenhum dado disponível',
  'The data will be cleared, are you sure': 'Os dados serão apagados, tem certeza?',
  'Search O/S UC Action Recommendations': 'Pesquisar Recomendações de Ação O/S UC',
  'Equipment Serial No/UnitNo': 'Nº de Série do Equipamento/Nº da Unidade',
  'Action Recommendation date is a future Date, which is not permissible in the Action Taken Screen, the system will use the current Date and Hour meter, please adjust accordingly': 'A data da recomendação de ação é uma data futura, o que não é permitido na tela de Ação Tomada. O sistema usará a data atual e o horímetro, por favor ajuste conforme necessário.',
  'Continue': 'Continuar',
  'Summary': 'Resumo',
  'Hide Favourites': 'Ocultar Favoritos',
  'Please use the Search field above to select what equipment you are shown.': 'Por favor, use o campo de pesquisa acima para selecionar qual equipamento será exibido.',
  'Asset Alt. Number': 'Número Alternativo do Ativo',
  'EQUIPMENT VIEW': 'VISÃO DO EQUIPAMENTO',
  'ASSET VIEW': 'VISÃO DO ATIVO',
  'ASSET LOCATION HISTORY': 'HISTÓRICO DE LOCALIZAÇÃO DO ATIVO',
  'Alt.Serial': 'Alt. Número',
  'Job #': 'Nº do Trabalho',
  'Select Side': 'Selecione o lado',
  'Select Unit Number': 'Selecione o número da unidade',
  'Unit No': 'Nº da Unidade',
  'Average Projected to 100%': 'Média Projetada para 100%',
  'Average Projected to 120%': 'Média Projetada para 120%',
  'Average Cost per Hour': 'Custo Médio por Hora',



  'Usage Distance': 'Distância Utilizada',
  'per day': 'por dia',
  'Planner': 'Planejador',

  "SMU Last Known Date": "Data da Última SMU Conhecida",
  "SMU Last Known SMU": "Última SMU Conhecida",
  "Distance Forward": "Distância para Frente",
  "Distance Reverse": "Distância para Trás",
  "Last Dist. Total": "Última Distância Total",
  "Last Known Dist. Date": "Data da Última Distância Conhecida",
  "Forward Distance": "Distância para Frente",
  "Reverse Distance": "Distância para Trás",
  "Total Distance": "Distância Total",
  "Close PM's": "Fechar PMs",
  // "Next Pm Service": "Próxima Manutenção PM",
  "2nd Pm Service": "2ª Manutenção PM",
  "Floating Date 1": "Data Flutuante 1",



  "Tools & Actions": "Ferramentas e Ações",
  "Display Options": "Opções de Exibição",
  "Enter SMU/Dates": "Inserir SMU/ Datas",
  "Last Inspect. Worn %": "% Desgaste Última Inspeção",
  "% Worn <br>Today": "% Desgaste <br>Hoje",
  "Floating Pm1 Service": "Serviço PM Flutuante 1",
  "Floating Pm2 Service": "Serviço PM Flutuante 2",
  "100 % Worn": "100%  Desgastado",
  "120 % Worn": "120% Desgastado",
  "Start Time": "Hora de Início",
  "Log Sent": "Registro Enviado",
  "Not Sent": "Não Enviado",
  "Lab Number": "Número do Laboratório",
  "Sent To Address": "Enviado Para o Endereço",
  "Please use the Search field above to select what Email Log you are shown.":
  "Use o campo de Pesquisa acima para selecionar qual Log de Email deseja visualizar.",
  "Next Pm Service Header": "Próximo \nServiço \n de MP",
  "2nd Pm Service Header": "2º Serviço \n de MP",
  "Floating Pm1 Service Header": "Serviço PM \nFlutuante 1",
  "Floating Pm2 Service Header": "Serviço PM \nFlutuante 2",
  "100 % Worn Header": "100% \n Desgastado",
  "120 % Worn Header": "120% \n Desgastado",
   "Last Inspect. Worn % Header": "% Desgaste \n Última\n Inspeção",
   'Last Known Dist. Date Header':"Data da Última\n Distância Conhecida",
    'SMU Last Known Date Header':'Data da Última \nSMU Conhecida',
    'SMU Last Known SMU Header':'Última SMU \nConhecida',
    'Distance Forward Header':'Distância \npara Frente',
    'Distance Reverse Header':'Distância \npara Trás',
    'Last Dist. Total Header':'Última \nDistância Total',
    'Forward Distance Header':'Distância \npara Frente',
    'Reverse Distance Header':'Distância \npara Trás',
    'UNDERCARRIAGE': 'SUBCARRIAGEM',
'Alert Name': 'Nome do Alerta',
'Frequency': 'Frequência',
'Enabled': 'Ativado',
'Email Enabled': 'Email Ativado',
'Percentage Worn': 'Percentual de Desgaste',
"Planning": "Planejamento",
 "Setup": "Configuração",
 "Parts Search": "Pesquisa de Peças",
 "Enter Safety Observation": "Inserir Observação de Segurança",
 "Search Safety Observations": "Pesquisar Observações de Segurança",
 "- Setup Departments/Work Areas": "Configurar Departamentos/Áreas de Trabalho",
 "- Setup Users": "Configurar Usuários",
 "- Setup Incident Types": "Configurar Tipos de Incidente",
 "- Setup Safety Questions": "Configurar Perguntas de Segurança",
  "Inductions": "Integrações",
  "Perform Induction": "Realizar Integração",
  "Search Induction": "Pesquisar Integração",
  "- Setup Induction Types & Sections": "Configurar Tipos e Seções de Integração",
  "- Setup Induction Slides": "Configurar Slides de Integração",
  "- Setup Induction Questions": "Configurar Perguntas de Integração",
  "Policies and Procedures": "Políticas e Procedimentos",
  "Leave": "Licença",
  "Leave Admin": "Administração de Licenças",
  "Safety": "Segurança",
  "Digital Inspections": "Inspeções Digitais",
  "Field Inspection Dashboard": "Painel de Inspeção de Campo",
  "Get & Wear Surfaces": "GET e Superfícies de Desgaste",
  "GET Inspections": "Inspeções GET",
  "New GET Inspection": "Nova Inspeção GET",
  "Asset Model Setup": "Configuração do Modelo de Ativo",
  "Document Library": "Biblioteca de Documentos",
  "PIP Setup": "Configuração PIP",
  "Warranty Tracking": "Rastreamento de Garantia",
  "Observation List Setup": "Configuração da Lista de Observação",
  "CRC Dashboard": "Painel CRC",
  "Undercarriage": "Subcarriagem",
  "Setup Additional Components": "Configurar Componentes Adicionais",
  "Dashboards": "Painéis",
  "Other Inspections": "Outras Inspeções",
  "HOME - Admin Access": "INÍCIO - Acesso Admin",
  "Safety Dashboard": "Painel de Segurança",
  "General Dashboard": "Painel Geral",
  "Safety Indicators": "Indicadores de Segurança",
  "- View/Edit Monthly Hours": "Visualizar/Editar Horas Mensais",
  "- Add Monthly Dashboard Message": "Adicionar Mensagem Mensal no Painel",
  "- Add Toolbox Talk": "Adicionar Toolbox Talk",
  "- Add Take 5s": "Adicionar Take 5",
  "- Setup Forms": "Configurar Formulários",
  "Upload Completed Paper Form": "Enviar Formulário em Papel Concluído",
  "Training Register": "Registro de Treinamento",
  "Search & Review Forms": "Pesquisar e Revisar Formulários",
  "Select Form": "Selecionar Formulário",
  'GET Dashboard': 'Painel GET',
  'TTadmin': 'Administrador TT',
  "Setup Departments/Work Areas": "Configurar Departamentos/Áreas de Trabalho",
  "Setup Users": "Configurar Usuários",
  "Setup Incident Types": "Configurar Tipos de Incidente",
  "Setup Safety Questions": "Configurar Perguntas de Segurança",
  "Action Description & Comment": "Descrição da Ação e Comentário",
  "Old Value": "Valor Antigo",
  "New Value": "Novo Valor",
  "Modified By": "Modificado Por",
  "Audit Trail": "Registro de Auditoria",
  "Screen": "Tela",
  'Copy Implement Advanced': 'Copiar Implementar Avançado', 
  'Cast': 'Elenco',
  'Unit #': 'unidade #',
  "Number of Observations": "Número de Observações",
  "Components Currently Using": "Componentes Atualmente em Uso",
  "Crack Obs. List": "Lista de Observações de Trincas",
  "Crack Severity List": "Lista de Severidade de Trincas",
  "Active": "Ativo",
  "Setup New List": "Configurar Nova Lista",
  "List Name": "Nome da Lista",
  "General Bucket Observations": "Observações Gerais do Balde",
  "Add Observation": "Adicionar Observação",
  "Enter Observation and Press Add": "Digite a Observação e Pressione Adicionar",
  "Observation List": "Lista de Observações",
  "Edit Observation List": "Editar Lista de Observações",
  "Add/Update": "Adicionar/Atualizar",
  "Observaton": "Observação",
  "There are no observation lists created for this customer. Click Add New to create one.": "Não há listas de observações criadas para este cliente. Clique em Adicionar Novo para criar uma.",
  "Existing Implement": "Implemento Existente",
  "Implement": "Implemento",
  "Selecting Copying of Schematics for Asset": "Selecionar Cópia de Esquemas para o Ativo",
  "Reference Schematics to Originating Templates": "Referenciar Esquemas aos Modelos Originais",
  "Specific Assets": "Ativos Específicos",
  "The Source Implement is not listed as fitting the Model of the Equipment you have selected,": "O implemento de origem não está listado como compatível com o modelo do equipamento selecionado,",
  "however if you wish to proceed it will be added.": "no entanto, se desejar prosseguir, ele será adicionado.",
  "Implement Hours at Setup": "Horas do Implemento na Configuração",
  "Implement Serial": "Serial do Implemento",
  "Select Component": "Selecionar Componente",
  "Component Name": "Nome do Componente",
  "Part No": "Nº da Peça",
  "Select Obs. Point": "Selecionar Ponto de Observação",
  "Observation Point": "Ponto de Observação",
  "OP Type": "Tipo de PO",
  "Update Image": "Atualizar Imagem",
  "Delete Image": "Excluir Imagem",
  "Fabricated": "Fabricado",
  "Meter Read / SMU": "Leitura do Medidor / SMU",
  "JSON": "JSON",
  "CSV Export": "Exportar CSV",
  "No Data Found - please can reset your selection and try again.": "Nenhum dado encontrado - por favor, redefina sua seleção e tente novamente.",
  "Start SMU": "SMU Inicial",
  "End SMU": "SMU Final",
  "Start CMU": "CMU Inicial",
  "End CMU": "CMU Final",
  "Start Dist": "Distância Inicial",
  "End Dist": "Distância Final",
  "Update Selection": "Atualizar Seleção",
  "On-Hire Inspection": "Inspeção de Entrada",
  "Off-Hire Inspection": "Inspeção de Saída",
  "Left % Used": "% Usado Esquerda",
  "Right % used": "% Usado Direita",
  "Original Cost": "Custo Original",
  "Leave a comment": "Deixe um comentário",
  "GET Inspection": "Inspeção GET",
  "Get Implement": "Obter Implemento",
  "Digital Forms": "Formulários Digitais",
  "Equipment SMU at Initial Install": "SMU do Equipamento na Instalação Inicial",
  "Implement Make": "Marca do Implemento",
  "Budget at Setup": "Orçamento na Configuração",
  "Implement Tons at Setup": "Toneladas do Implemento na Configuração",
  "Hours on Implement at Setup": "Horas do Implemento na Configuração",
  "Skip Changes & Go To Next": "Ignorar Alterações e Ir para o Próximo",
  "Save Changes & Go To Next": "Salvar Alterações e Ir para o Próximo",
  'System Calculated Usage': 'Utilização Calculada pelo Sistema',
  'Manually Entered Usage': 'Utilização com Entrada Manual',
  'Eqiup Unit#' : 'Nº do Equipamento',
  "Please select an Implement to inspect first!": "Por favor, selecione um implemento para inspecionar primeiro!",
  "Equipment Smu at Install": "SMU do Equipamento na Instalação",
  "Equipment SMU at Inspection": "SMU do Equipamento na Inspeção",
  "Include Cover Page on report": "Incluir página de capa no relatório",
  "Include Overall Comment on Report": "Incluir comentário geral no relatório",
  "Work Required": "Trabalho Necessário",
  "Job File #": "Número do Arquivo do Trabalho #",
  "Repair Request #": "Número da Solicitação de Reparo #",
  "Select Schematic to add an observation point/Crack (Click on thumbnail)": "Selecione o esquema para adicionar um ponto de observação/rachadura (clique na miniatura)",
  "Part#": "Número da Peça #",
  "Wear Limit": "Limite de Desgaste",
  "Question": "Pergunta",
  "Instructions": "Instruções",
  "Location Name": "Nome da Localização",
  "Obs. List": "Lista de Obs.",
  "Severity List": "Lista de Severidade",
  "Incl. Rep.": "Incl. no Rel.",
  "Refresh with Asset Type Report Options": "Atualizar com opções de relatório por tipo de ativo",
  "ReCalculate Inspection": "Recalcular inspeção",
  "Inspection Images": "Imagens de inspeção",
  "Observation Point View": "Visualização do ponto de observação",
  "Area Inspected": "Área inspecionada",
  "Eng. Evaluation": "Avaliação de engenharia",
  "Addressed To": "Endereçado a",
  "Location": "Localização",
  "Component Type comment for Report": "Comentário do tipo de componente para o relatório",
  "Report Configuration": "Configuração do relatório",
  "Pre-Inspection Checklist": "Lista de verificação pré-inspeção",
  "Tray Report Configuration": "Configuração do relatório da bandeja",
  "Save Report Configuration At Asset Type": "Salvar configuração de relatório no tipo de ativo",
  "Alternate Group Name": "Nome alternativo do grupo",
  "Include in Report Summary": "Incluir no resumo do relatório",
  "Include Graph in Summary": "Incluir gráfico no resumo",
  "Summary Eval": "Avaliação do resumo",
  "Include Schematic in Summary": "Incluir esquema no resumo",
  "Image Rotation": "Rotação da imagem",
  "Summary Comment": "Comentário do resumo",
  "Enter a Summary Comment.": "Digite um comentário do resumo",
  "Include in Report Body": "Incluir no corpo do relatório",
  "Include Data Table": "Incluir tabela de dados",
  "Include Graph": "Incluir gráfico",
  "Pie Chart": "Gráfico de pizza",
  "Speedometer Chart": "Gráfico de velocímetro",
  'Undercarriage Rebuild Centre': 'Centro de Reconstrução de Trem de Pouso',
  "Start New Undercarriage Rebuild Center": "Iniciar Novo Centro de Reconstrução do Material Rodante",
  "Find Undercarriage Rebuild Centre": "Encontrar Centro de Reconstrução do Material Rodante",
  "Frame Undercarriage Rebuild Centre": "Centro de Reconstrução do Material Rodante (Estrutura)",
  "Chain Undercarriage Rebuild Centre": "Centro de Reconstrução do Material Rodante (Corrente)",
  "Alerts (Current)": 'Alertas (Atuais)',
  "Source": 'Fonte',
  "Move to History": 'Mover para o histórico',
  "Alert History": 'Histórico de alertas',
  "Move to Current": 'Mover para atuais',
  'Selection': 'Seleção',
  'Pass/Fail': 'Aprovado/Reprovado',
  'Yes/No': 'Sim/Não',
  'Reading No.': 'Número da Leitura',
  'Accepted': 'Aceito',
  'Monitor': 'Monitorar',
  'Not Accepted': 'Não Aceito',
  'Pass': 'Aprovado',
  'Fail': 'Reprovado',
  "NA": "N/D",
  "NO": "Não",
  "YES": "Sim",
  "Enter Equipment Summary Notes...": "Insira notas resumidas do equipamento...",
  "Created On": "Criado em",
  "Summary Notes": "Notas resumidas",
  "Last Modified On": "Última modificação em",
  "Last Modified By": "Última modificação por",
  "Edit Summary Notes": "Editar notas resumidas",
  "Equipment Summary Notes": "Notas resumidas do equipamento",
  "DNET Cost": "Custo DNET",
  "Search Result": "Resultado da Pesquisa",
  "Request New Chain": "Solicitar Nova Corrente",
  "Chain Des": "Descrição da Corrente",
  "Serial Number Start": "Número de Série Inicial",
  "Serial Number End": "Número de Série Final",
  "Pitch": "Passo",
  "# Of Links": "Nº de Elos",
  "Part Required": "Peça Necessária",
  "Component Description": "Descrição do Componente",
  "PartLine": "Linha da Peça",
  "Quantity Required": "Quantidade Necessária",
  "Quantity in Stock": "Quantidade em Estoque",
  "DNET  Cost Each": "Custo Unitário DNET",
  "DNET  Cost Total": "Custo Total DNET",
  "Add to Part List": "Adicionar à Lista de Peças",
  "Request Part List": "Solicitar Lista de Peças",
  "Comments": "Comentários",
  "Parts": "Peças",
  "Send Email": "Enviar Email",
  "Summary Notes History": "Histórico das Notas Resumidas",
  "Request A New Chain": "Solicitar uma Nova Corrente",
  "Email is required": "O e-mail é obrigatório",
  "Email is invaild": "O e-mail é inválido",
  "Model Required": "Modelo Obrigatório",
  "A Model is required": "Um modelo é obrigatório",
  "Make Required": "Marca Obrigatória",
  "A Make is required": "Uma marca é obrigatória",
  "Chain Description": "Descrição da Corrente",
  "Part Search": "Pesquisa de Peça",
  "Edit Favourite": "Editar Favorito",
  "Update Favourite": "Atualizar Favorito",
  "Form Category": "Categoria do Formulário",
  "Select Form Category": "Selecionar Categoria do Formulário",
  "Machine": "Máquina",
  "Select Machine": "Selecionar Máquina",
  "Form Name": "Nome do Formulário",
  "Select Form Name": "Selecionar Nome do Formulário",
  "Select Inspector": "Selecionar Inspetor",
  "Select Custom Date Range": "Selecionar Intervalo de Datas Personalizado",
  "Not Started": "Não Iniciado",
  "In Progress": "Em Progresso",
  "In Review": "Em Revisão",
  "Completed": "Concluído",
  "Attention Required": "Atenção Necessária",
  "Multiple Answers": "Múltiplas Respostas",
  "Comment Added": "Comentário Adicionado",
  "Show/Hide": "Mostrar/Ocultar",
  "SerialNo": "Número de Série",
  "UnitNo": "Número da Unidade",
  "SMU Difference": "Diferença de SMU",
  "Serial no": "Número de Série",
  "Unit no": "Número da Unidade",
  "SMR": "SMR",
  "Fail - Attention Required": "Falha - Atenção Necessária",
  "False/Unable to Answer - Immediate Action required": "Falso/Incapaz de Responder - Ação Imediata Necessária",
  "Report Options": "Opções de Relatório",
  "Report Option": "Opção de Relatório",
  "Generate PDF": "Gerar PDF",
  "In Progress/Completed": "Em Progresso/Concluído",
  "Available Forms": "Formulários Disponíveis",
  "Linked Models": "Modelos Vinculados",
  "Linked Customers": "Clientes Vinculados",
  "Start New": "Iniciar Novo",
  "AVAILABLE FORMS": "FORMULÁRIOS DISPONÍVEIS",
  "Create New Form": "Criar Novo Formulário",
  "Copy": "Copiar",
  "Edit Form": "Editar Formulário",
  "Copy Form": "Copiar Formulário",
  "Select Asset/System Type": "Selecionar Tipo de Ativo/Sistema",
  "Select Asset Serial Number": "Selecionar Número de Série do Ativo",
  "Add Serial Number": "Adicionar Número de Série",
  "Please use the Search field above to select what inspection you are shown.": "Use o campo de pesquisa acima para selecionar quais inspeções deseja visualizar.",
  "Warranty Type Setup": "Configuração do Tipo de Garantia",
  "Warranty Type": "Tipo de Garantia",
  "Enter Warranty Type Name": "Digite o Nome do Tipo de Garantia",
  "Include": "Incluir",
  "Hours Usage": "Uso em Horas",
  "Enter Hours": "Digite as Horas",
  "Enter Days": "Digite os Dias",
  "Cycles": "Ciclos",
  "Enter Cycles": "Digite os Ciclos",
  "In-Active": "Inativo",
  "Save/Update": "Salvar/Atualizar",
  "Product Improvement Program Search": "Pesquisa de Programa de Melhoria de Produto",
  "Select Build #": "Selecionar Build #",
  "Serial # Start": "Número de Série Inicial",
  "Enter Serial # Start": "Digite o Número de Série Inicial",
  "Serial # End": "Número de Série Final",
  "Enter Serial # End": "Digite o Número de Série Final",
  "PIP Number": "Número PIP",
  "Enter Heading": "Digite o Título",
  "Enter Heading Placeholder": "Digite o Título",
  "Program Start Date": "Data Inicial do Programa",
  "Program End Date": "Data Final do Programa",
  "PIP#": "PIP#",
  "Heading": "Título",
  "Built #": "Build #",
  "SN# Start": "SN# Inicial",
  "SN# End": "SN# Final",
  "Support Pro.": "Programa de Suporte",
  "Show Less": "Mostrar Menos",
  "Show More": "Mostrar Mais",
  "Asset SN#": "SN do Ativo",
  "Unit#": "Unidade#",
  "Expired": "Expirado",
  "Product Improvement Program": "Programa de Melhoria de Produto",
  "Return to Search Screen": "Retornar à Tela de Pesquisa",
  "Select Built #": "Selecionar Build #",
  "Enter PIP Number": "Digite o Número PIP",
  "Enter PIP Description": "Digite a Descrição do PIP",
  "Supporting Doc.": "Documento de Suporte",
  "Support Pro Associated with PIP": "Programa de Suporte Associado ao PIP",
  "Support Program Notes": "Notas do Programa de Suporte",
  "Enter Support Program Notes": "Digite as Notas do Programa de Suporte",
  "Generate Alert": "Gerar Alerta",
  "Select Warranty Type": "Selecionar Tipo de Garantia",
  "Select Start Date": "Selecionar Data Inicial",
  "Enter Starting SMU": "Inserir SMU Inicial",
  "Enter Starting Cycle #": "Inserir Ciclo Inicial #",
  "Set Default": "Definir Padrão",
  "Original Warranty": "Garantia Original",
  "Commencement Date": "Data de Início",
  "Commencement SMU": "SMU Inicial",
  "Original CMU": "CMU Original",
  "Residual Warranty": "Garantia Residual",
  "Current Date": "Data Atual",
  "Current SMU": "SMU Atual",
  "Approval Request": "Solicitação de Aprovação",
  "Approval Response": "Resposta de Aprovação",
  "% Complete": "% Completo",
  "Total Hours ": "Total de Horas",
  "Total Cost ": "Custo Total",
  "Product Improvement": "Melhoria de Produto",
  "PIP No": "Número PIP",
  "Completed Date": "Data de Conclusão",
  "PIP Notes": "Notas do PIP",
  "Open": "Aberto",
  "View Photo": "Visualizar Foto",
  "Replace Photo": "Substituir Foto",
  "Repairer": "Reparador",
  "Implement Rebuild's Status": "Status da Reconstrução do Implemento",
  "Ready to Rebuild": "Pronto para Reconstrução",
  "Pre Shipped": "Pré-Enviado",
  "Shipped": "Enviado",
  "Disassembled": "Desmontado",
  "SOW-Approvals": "SOW-Aprovações",
  "WIP": "Em Progresso",
  "Ready to Ship": "Pronto para Envio",
  "Complete": "Concluído",
  "Remove Component From Equipment": "Remover Componente do Equipamento",
  "Create New Component": "Criar Novo Componente",
  "Clear History": "Limpar Histórico",
  "Make Setup": "Configuração da Marca",
  "Select Existing Make": "Selecionar Marca Existente",
  "Make Details": "Detalhes da Marca",
  "Make ID": "ID da Marca",
  "Enter Make ID": "Digite o ID da Marca",
  "Make Name": "Nome da Marca",
  "Enter Make Name": "Digite o Nome da Marca",
  "OEM": "OEM",
  "Model Search": "Pesquisa de Modelo",
  "Family Setup": "Configuração da Família",
  "Select Existing Family": "Selecionar Família Existente",
  "Family Details": "Detalhes da Família",
  "Family ID": "ID da Família",
  "Family Name": "Nome da Família",
  "Family Image": "Imagem da Família",
  "Show Distance Travelled Tracking Option on Equipment Setup": "Mostrar opção de rastreamento de distância percorrida na configuração do equipamento",
  "Show Propel Hours and % on Equipment": "Mostrar horas de propulsão e % no equipamento",
  "Enable Equaliser Bar Type Fields": "Habilitar campos do tipo barra equalizadora",
  "Enable Track Tension Indicator Installed Fields": "Habilitar campos do indicador de tensão da esteira",
  "Enable Frame Configuration": "Habilitar configuração do quadro",
  "Enable Cannon Type": "Habilitar tipo de canhão",
  "Enable Bogie Shim": "Habilitar calço do bogie",
  "Enable Manual Inspection Pdf": "Habilitar PDF de inspeção manual",
  "Enable Track Sag": "Habilitar folga da esteira",
  "Enable Cannon Extension": "Habilitar extensão do canhão",
  "Enable Scallop": "Habilitar scallop",
  "Enable Dry Joints": "Habilitar juntas secas",
  "Enable # of Links": "Habilitar nº de links",
  "Enable Under Foot Conditions": "Habilitar condições do solo",
  "Enable Work Order": "Habilitar ordem de serviço",
  "Enable Thermal Image": "Habilitar imagem térmica",
  "Enable Additional Inspectors": "Habilitar inspetores adicionais",
  "Chain Image": "Imagem da Corrente",
  "Choose Chain Image": "Escolher imagem da corrente",
  "Frame Image": "Imagem do Quadro",
  "Choose Frame Image": "Escolher imagem do quadro",
  "Lookup": "Pesquisa",
  "Job Role": "Função de Trabalho",
  "Role Name": "Nome da Função",
  "Role Notes": "Notas da Função",
  "Admin Role": "Função Administrador",
  "Update Roles": "Atualizar Funções",
  "Update Permissions": "Atualizar Permissões",
  "User Name": "Nome do Usuário",
  "Select the model you would like to view/edit": "Selecione o modelo que deseja visualizar/editar",
  "No data available!": "Nenhum dado disponível!",
  "Model Details": "Detalhes do Modelo",
  "Model ID": "ID do Modelo",
  "Model Description": "Descrição do Modelo",
  "Industry": "Indústria",
  "Default Inspection Cycle": "Ciclo de Inspeção Padrão",
  "BaseModel": "Modelo Base",
  "Model Note": "Nota do Modelo",
  "Component Detail": "Detalhe do Componente",
  "Upload to Mobile": "Enviar para Mobile",
  "Chains Available": "Correntes Disponíveis",
  "Add Chain": "Adicionar Corrente",
  "# of Links": "Nº de Links",
  "No Of Links": "Número de Links",
  "Link Height": "Altura do Link",
  "Number of Idlers": "Número de Roletes",
  "Bolt Hole Diameter": "Diâmetro do Furo do Parafuso",
  "Bushing Outside Diameter": "Diâmetro Externo da Bucha",
  "Number Of CarrierRollers": "Número de Rolos Transportadores",
  "Chain Spread Inside": "Abertura Interna da Corrente",
  "Chain Spread Outside": "Abertura Externa da Corrente",
  "Number Of TrackRollers": "Número de Rolos de Esteira",
  "Hardware": "Hardware",
  "Berco Part Number": "Número da Peça Berco",
  "Case Part Number": "Número da Peça Case",
  "Quantity": "Quantidade",
  "Part Line": "Linha de Peça",
  "Component Details": "Detalhes do Componente",
  "Component ID": "ID do Componente",
  "Component Type Availability": "Disponibilidade do Tipo de Componente",
  "Observation Details": "Detalhes da Observação",
  "Mobile Screen Display of Observations:": "Exibição das observações na tela mobile:",
  "Equipment Conditions": "Condições do Equipamento",
  "Components Screen": "Tela de Componentes",
  "Visibility": "Visibilidade",
  "Update Limits": "Atualizar Limites",
  "Admin Role - allows edit functions in the equipment details screen": "Função Administrador - permite funções de edição na tela de detalhes do equipamento",
  "Undercarriage Component Types": "Tipos de Componentes do Material Rodante",
  "Component Image": "Imagem do Componente",
  "Component Family": "Família do Componente",
  "Component Type Name": "Nome do Tipo de Componente",
  "Information": "Informação",
  "Please enter component extra details prior to sprocket hardware": "Por favor, insira detalhes extras do componente antes do hardware da roda dentada",
  "Ok": "Ok",
  "Undercarriage Worn Limit Management": "Gerenciamento de Limites de Desgaste do Material Rodante",
  "Select Part #": "Selecionar Peça #",
  "Select Tool Used": "Selecionar Ferramenta Utilizada",
  "High Impact": "Alto Impacto",
  "Low Impact": "Baixo Impacto",
  "Comp. Type": "Tipo de Comp.",
  "Part #": "Peça #",
  "Method": "Método",
  "Tool Used": "Ferramenta Utilizada",
  "Slope": "Inclinação",
  "Adjust to Base": "Ajustar à Base",
  "Inflect Pt.": "Ponto de Inflexão",
  "Slope1": "Inclinação1",
  "Y Int.1": "Intercepção Y1",
  "Slope2": "Inclinação2",
  "Y Int.2": "Intercepção Y2",
  "Starting Dim": "Dimensão Inicial",
  "100% Worn": "100% Desgastado",
  "No records to display.": "Nenhum registro para exibir.",
  "New High": "Novo Alto",
  "New Low": "Novo Baixo",
  "Polynomial Worn Limits": "Limites de Desgaste Polinomiais",
  "Impact 2nd Order": "Impacto 2ª Ordem",
  "Normal 2nd Order": "Normal 2ª Ordem",
  "Impact Slope": "Inclinação de Impacto",
  "Normal Slope": "Inclinação Normal",
  "Impact Intercept": "Interceptação de Impacto",
  "Normal Intercept": "Interceptação Normal",
  "Linear Worn Limits": "Limites de Desgaste Lineares",
  "Worn Limit Setup": "Configuração de Limite de Desgaste",
  "Method of Calculation": "Método de Cálculo",
  "Tools": "Ferramentas",
  "U/C Make": "Marca U/C",
  "Adjustment to Base": "Ajuste para Base",
  "H.I. - Inflection Point": "A.I. - Ponto de Inflexão",
  "M.I. - Inflection Point": "M.I. - Ponto de Inflexão",
  "H.I. - Slope 1": "A.I. - Inclinação 1",
  "M.I. - Slope 1": "M.I. - Inclinação 1",
  "H.I. -Y Intercept 1": "A.I. - Intercepção Y 1",
  "M.I. -Y Intercept 1": "M.I. - Intercepção Y 1",
  "H.I. - Slope 2": "A.I. - Inclinação 2",
  "M.I. - Slope 2": "M.I. - Inclinação 2",
  "H.I. -Y Intercept 2": "A.I. - Intercepção Y 2",
  "M.I. -Y Intercept 2": "M.I. - Intercepção Y 2",
  "Worn Dimension": "Dimensão Desgastada",
  "Impact": "Impacto",
  "Start Depth.New": "Profundidade Inicial.Nova",
  "Wear Depth": "Profundidade de Desgaste",
  "Normal": "Normal",
  "Slope Direction - Impact": "Direção da Inclinação - Impacto",
  "Slope Direction - Normal": "Direção da Inclinação - Normal",
  "Add New Limit": "Adicionar Novo Limite",
  "Add Dealer Group Branded Style": "Adicionar Estilo de Marca do Grupo de Concessionárias",
  "Select Dealer Group": "Selecionar Grupo de Concessionárias",
  "Colour Scheme": "Esquema de Cores",
  "Select Colour Scheme": "Selecionar Esquema de Cores",
  "Upload a logo for the Dealer Group. Recommended 77px by 35px.": "Carregue um logotipo para o Grupo de Concessionárias. Recomendado 77px por 35px.",
  "Update Branded Style": "Atualizar Estilo de Marca",
  "Worn Spec": "Especificação de Desgaste",
  "Tolerance": "Tolerância",
  "Plus": "Mais",
  "Minus": "Menos",
  "Max": "Máximo",
  "Add Measurement Image": "Adicionar Imagem de Medição",
  "Tool Name": "Nome da Ferramenta",
  "Currently applying to": "Aplicando atualmente a",
  "selected machines": "máquinas selecionadas",
  "For your selection the system is currently using the default ranges. These are shown below": "Para sua seleção o sistema está usando atualmente os intervalos padrão. Eles são mostrados abaixo",
  "For your selection site default limits display.These are shown below.": "Para sua seleção os limites padrão do site são exibidos abaixo.",
  "Limit display for selected machine.": "Exibição de limites para a máquina selecionada.",
  "For your selection the system is currently using the dealer ranges. These are shown below": "Para sua seleção o sistema está usando atualmente os intervalos do concessionário. Eles são mostrados abaixo",
  "For your selection the system is currently using the customer ranges. These are shown below": "Para sua seleção o sistema está usando atualmente os intervalos do cliente. Eles são mostrados abaixo",
  "Create New Measurement Point": "Criar Novo Ponto de Medição",
  "Rope Shovel/Hydraulic Shovel": "Escavadeira a Cabo/Escavadeira Hidráulica",
  "URC": "URC",
  "Component Note": "Nota do Componente",
  "SMCS Job Code": "Código de Trabalho SMCS",
  "Budget Life (Hours)": "Vida Útil Planejada (Horas)",
  "Populate from USCO": "Preencher do USCO",
  "Component Make": "Marca do Componente",
  "Measurement Images": "Imagens de Medição",
  "Unit number": "Número da Unidade",
  "Level": "Nível",
  "Default Tool": "Ferramenta Padrão",
  "Select a Default Tool": "Selecione uma Ferramenta Padrão",
  "Please Select a default tool": "Selecione uma ferramenta padrão",
  "True": "Verdadeiro",
  "False": "Falso",
  "Inspection Type cannot exceed 50 characters.": "O tipo de inspeção não pode exceder 50 caracteres.",
  "Standard Cost Repair": "Custo Padrão de Reparo",
  "Standard Hours Repair": "Horas Padrão de Reparo",
  "You can attach a photo of this measurement point ": "Você pode anexar uma foto deste ponto de medição",
  "Add Measurement Points": "Adicionar Pontos de Medição",
  "Copy Obs. Pts.": "Copiar Pontos de Obs.",
  "Select Filters to display and edit data": "Selecione Filtros para exibir e editar dados",
  "Component Setup": "Configuração de Componentes",
  "Component Search": "Pesquisa de Componentes",
  "Equipment Make": "Marca do Equipamento",
  "Equipment Model": "Modelo do Equipamento",
  "Default Tool Used": "Ferramenta Padrão Utilizada",
  "Search and Review Forms": "Pesquisar e Revisar Formulários",
  "Enter Safety Inspection - Web Browser": "Inserir Inspeção de Segurança - Navegador Web",
  "Search Safety Inspections": "Pesquisar Inspeções de Segurança",
  "Upload Completed Forms": "Carregar Formulários Concluídos",
  "Configuration": "Configuração",
  "Add Take 5's": "Adicionar Take 5",
  "Add Toolbox Talk": "Adicionar Conversa de Segurança",
  "Add Monthly Dashboard Message": "Adicionar Mensagem Mensal do Painel",
  "View/Edit Monthly Hours": "Visualizar/Editar Horas Mensais",
  "Setup Induction Slides": "Configurar Slides de Integração",
  "Setup Induction Questions": "Configurar Perguntas de Integração",
  "Setup Induction Types and Sections": "Configurar Tipos e Seções de Integração",
  "Safety Inspections": "Inspeções de Segurança",
  "Setup Safety Checklist": "Configurar Checklist de Segurança",
  "Setup Digital Forms": "Configurar Formulários Digitais",
  "All State": "Todos os Estados",
  "All States": "Todos os Estados",
  "Checks Completed": "Verificações Concluídas",
  "Current Count": "Contagem Atual",
  "Target for Month": "Meta para o Mês",
  "Target for Date": "Meta para a Data",
  "Checks with Fails": "Verificações com Falhas",
  "Failed Items": "Itens com Falha",
  "Since Last Fail": "Desde a Última Falha",
  "Incident Counts": "Contagem de Incidentes",
  "Last MTI": "Último MTI",
  "Last LTI": "Último LTI",
  "Focus Items": "Itens de Foco",
  "Take 5's for Period": "Take 5 do Período",
  "Target": "Meta",
  "Actual": "Real",
  "Previous 12 Mths Hours": "Horas dos Últimos 12 Meses",
  "Previous 12 Mths TRIFR": "TRIFR dos Últimos 12 Meses",
  "Last 12 Months": "Últimos 12 Meses",
  "Areas of Improvements": "Áreas de Melhoria",
  "Positives": "Pontos Positivos",
  "Activities": "Atividades",
  "Incidents": "Incidentes",
  "Observation Type": "Tipo de Observação",
  "Work Area": "Área de Trabalho",
  "Office": "Escritório",
  "Month-Year": "Mês-Ano",
  "January": "Janeiro",
  "March": "Março",
  "April": "Abril",
  "June": "Junho",
  "July": "Julho",
  "August": "Agosto",
  "September": "Setembro",
  "October": "Outubro",
  "November": "Novembro",
  "December": "Dezembro",
  "Month": "Mês",
  "Year": "Ano",
  "Number": "Número",
  "Add New Observation": "Adicionar Nova Observação",
  "Department": "Departamento",
  "Task Observed": "Tarefa Observada",
  "Setup Departments": "Configurar Departamentos",
  "Add Work Area": "Adicionar Área de Trabalho",
  "Add Department": "Adicionar Departamento",
  "Incident Types": "Tipos de Incidente",
  "Add Incident Type": "Adicionar Tipo de Incidente",
  "Setup Questions": "Configurar Perguntas",
  "Add Question": "Adicionar Pergunta",
  "Add New Category": "Adicionar Nova Categoria",
  "Add Induction Type": "Adicionar Tipo de Integração",
  "Induction Type": "Tipo de Integração",
  "Add Slide": "Adicionar Slide",
  "Safety Observation Search": "Pesquisa de Observação de Segurança",
  "Select Work Area": "Selecionar Área de Trabalho",
  "Select Category": "Selecionar Categoria",
  "Select Department": "Selecionar Departamento",
  "Select Contractor": "Selecionar Contratado",
  "Select Question": "Selecionar Pergunta",
  "Supplier": "Fornecedor",
  "Follow Up Required": "Acompanhamento Necessário",
  "Follow Up Completed": "Acompanhamento Concluído",
  "Only Unsafe": "Somente Inseguro",
  "Exclude N/A": "Excluir N/A",
  "Only Inspections": "Somente Inspeções",
  "Show Department": "Mostrar Departamento",
  "Show Work Area": "Mostrar Área de Trabalho",
  "Show Observer": "Mostrar Observador",
  "Category": "Categoria",
  "Safe/Unsafe": "Seguro/Inseguro",
  "Unsafe": "Inseguro",
  "Safe": "Seguro",
  "Observer": "Observador",
  "No Data Found for this search criteria.": "Nenhum dado encontrado para este critério de pesquisa.",
  "Induction": "Integração",
  "Select Induction Type": "Selecionar Tipo de Integração",
  "Select State": "Selecionar Estado",
  "Facilitator": "Facilitador",
  "User (Already setup) being Inducted": "Usuário (já configurado) sendo integrado",
  "User (Not setup) being Inducted": "Usuário (não configurado) sendo integrado",
  "Start": "Iniciar",
  "Slide": "Slide",
  "Ans": "Resposta",
  "Issue Start Date": "Data Inicial de Emissão",
  "Issue End Date": "Data Final de Emissão",
  "Document Heading": "Título do Documento",
  "Date Issued": "Data de Emissão",
  "Expiry Date": "Data de Expiração",
  "Field Changed": "Campo Alterado",
  "From": "De",
  "To": "Para",
  "New Leave Request": "Nova Solicitação de Licença",
  "Update Leave Request": "Atualizar Solicitação de Licença",
  "Leave Requests": "Solicitações de Licença",
  "Leave Administration": "Administração de Licenças",
  "Leave Type": "Tipo de Licença",
  "Leave From": "Licença De",
  "Leave To": "Licença Até",
  "Attach Doc.": "Anexar Documento",
  "Attachment": "Anexo",
  "Administration By": "Administrado Por",
  "Approved By": "Aprovado Por",
  "Requested User": "Usuário Solicitante",
  "Field Change": "Alteração de Campo",
  "Filter user": "Filtrar usuário",
  "Filter customer": "Filtrar cliente",
  "Filter job site": "Filtrar local de trabalho",
  "Filter dealership": "Filtrar concessionária",
  "Filter dealer group": "Filtrar grupo de concessionárias",
  "Pending": "Pendente",
  "Cancel Invite": "Cancelar Convite",
  "Support Team Access": "Acesso da Equipe de Suporte",
  "Dealer Group Access": "Acesso ao Grupo de Concessionárias",
  "Dealer Access": "Acesso da Concessionária",
  "Customer Access": "Acesso do Cliente",
  "Jobsite Access": "Acesso ao Local de Trabalho",
  "Equipment Access": "Acesso ao Equipamento",
  "Reset Password": "Redefinir Senha",
  "Contact Email": "Email de Contato",
  "Job Sites/th": "Locais de Trabalho",
  "Dealership": "Concessionária",
  "Dealership Name": "Nome da Concessionária",
  "Safety Observation Dashboard": "Painel de Observações de Segurança",
  "Safety General Dashboard": "Painel Geral de Segurança",
  "Add Monthly Dashboard Messages": "Adicionar Mensagens Mensais ao Painel",
  "Select a Form": "Selecionar um Formulário",
  "Report / Incident # required": "Relatório / Nº de Incidente obrigatório",
  "Digital Form": "Formulário Digital",
  "Add Form": "Adicionar Formulário",
  "Add Form Category": "Adicionar Categoria de Formulário",
  "Upload Forms": "Enviar Formulários",
  "Add File(s)": "Adicionar Arquivo(s)",
  "Related User": "Usuário Relacionado",
  "Add Image(s)": "Adicionar Imagem(ns)",
  "Report/Incident ID": "ID do Relatório/Incidente",
  "Incident Type": "Tipo de Incidente",
  "Follow Up Date": "Data de Acompanhamento",
  "Follow Up User": "Usuário de Acompanhamento",
  "Form Search": "Pesquisa de Formulários",
  "Date Start": "Data Inicial",
  "Date End": "Data Final",
  "Form": "Formulário",
  "Person Responsible": "Pessoa Responsável",
  "Due Date Start": "Data de Vencimento Inicial",
  "Due Date End": "Data de Vencimento Final",
  "Suspended User": "Usuário Suspenso",
  "Suspended Related Users": "Usuários Relacionados Suspensos",
  "Archived Forms": "Formulários Arquivados",
  "Active Forms": "Formulários Ativos",
  "Form Type": "Tipo de Formulário",
  "Add to Archive": "Adicionar ao Arquivo",
  "All Positions": "Todas as Funções",
  "All Forms": "Todos os Formulários",
  "All Users": "Todos os Usuários",
  "Date Completed": "Data Concluída",
  "Induction Search": "Pesquisa de Integração",
  "First Name": "Primeiro Nome",
  "Last Name": "Sobrenome",
  "Company": "Empresa",
  "Show Valid": "Mostrar Válidos",
  "Show Invalid": "Mostrar Inválidos",
  "No Data Found - Please reset and try again.": "Nenhum dado encontrado. Redefina e tente novamente.",
  "VALID": "VÁLIDO",
  "Focus Item": "Item de Foco",
  "Areas Of Improvement": "Áreas de Melhoria",
  "Take 5 target": "Meta Take 5",
  "Safety Inspection target": "Meta de Inspeção de Segurança",
  "Take 5 Target": "Meta Take 5",
  "Safety Inspection Target": "Meta de Inspeção de Segurança",
  "Select Equipment for Hire Report": "Selecionar Equipamento para Relatório de Locação",
  "Idler Setup": "Configuração do Rolete Guia",
  "Idler From Inventory": "Rolete Guia do Inventário",
  "Chain Setup": "Configuração da Corrente",
  "Chain From Inventory": "Corrente do Inventário",
  "Frame Setup": "Configuração da Estrutura",
  "Frame From Inventory": "Estrutura do Inventário",
  "Add New Inspection": "Adicionar Nova Inspeção",
  "Additional Component Setup": "Configuração de Componente Adicional",
  "Additional Component Selection": "Seleção de Componente Adicional",
  "Additional Component Details": "Detalhes do Componente Adicional",
  "Select the component you would like to edit the measurement points for": "Selecione o componente para o qual deseja editar os pontos de medição",
  "Model Image": "Imagem do Modelo",
  "Model Image Left": "Imagem Esquerda do Modelo",
  "Model Image Right": "Imagem Direita do Modelo",
  "Average wear rates used in Forecasting": "Taxas médias de desgaste usadas na previsão",
  "Base Model": "Modelo Base",
  "Compart": "Compartimento",
  "Search Document in Library": "Pesquisar Documento na Biblioteca",
  "Select Doc. Type": "Selecionar Tipo de Documento",
  "Select Doc. Status": "Selecionar Status do Documento",
  "Select End Date": "Selecionar Data Final",
  "Doc. Type": "Tipo de Documento",
  "Add Document in Library": "Adicionar Documento à Biblioteca",
  "Edit Document in Library": "Editar Documento na Biblioteca",
  "Automatically Add to Assets defined by above selection criteria": "Adicionar automaticamente aos ativos definidos pelos critérios de seleção acima",
  "Additional Component Name": "Nome do Componente Adicional",
  "Select System": "Selecionar Sistema",
  "No System": "Sem Sistema",
  "No Side": "Sem Lado",
  "Please select a Model": "Selecione um Modelo",
  "Apply Models...": "Aplicar Modelos...",
  "You can attach a photo.": "Você pode anexar uma foto.",
  "JobSite": "Local de Trabalho",
  "Is Bogie": "Est un Bogie",
  "UC Planner": "Planejador de Material Rodante",
  "SMU & PMU Input": "Entrada de SMU e PMU",
  "Search URC": "Pesquisar URC",
  "New Undercarriage Rebuild Center": "Novo Centro de Reconstrução de Material Rodante",
  "MidPoint %":"Ponto médio %",
  'Inspection Document Register': 'Registro de Documentos de Inspeção',
  'Include in Report (PDFs Only)': 'Incluir no Relatório (Somente PDFs)',
  'Attachments': 'Anexos',
  'Select Date': 'Selecionar Data',
  'Select Document Type': 'Selecionar Tipo de Documento',
  "Training Center": "Centro de Treinamento",
  "All Topics": "Todos os Tópicos",
  "Filter by Topic": "Filtrar por Tópico",
  "Edit Additional Observation": "Editar Observação Adicional",
  'User Preferences ': 'Preferências do Usuário',
  'Report Name': 'Nome do Relatório',
  "Forecast Seasonal Date Ranges": "Previsão de Intervalos de Datas Sazonais",
};